"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8726],{

/***/ 39896:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "e": function() { return /* binding */ createClient; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(20406);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(28526);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
;// CONCATENATED MODULE: ../../libs/utils/retry/retry.ts



var wait = function wait(waitTime) {
  return new Promise(function (resolve) {
    setTimeout(resolve, waitTime);
  });
};

var numberSuffixes = ["st", "nd", "rd"];

var functionFailedText = function functionFailedText(iteration) {
  var _numberSuffixes$itera;

  return "Function failed. Retrying ".concat(iteration + 1).concat((_numberSuffixes$itera = numberSuffixes[iteration]) !== null && _numberSuffixes$itera !== void 0 ? _numberSuffixes$itera : "th", " time...");
};

var allRetriesFailedText = function allRetriesFailedText(retriesCount, errors) {
  return "Function failed too many times. Tired ".concat(retriesCount, " time").concat(retriesCount > 1 ? "s" : "", ".\nThrown errors:\n").concat(errors.map(function (e) {
    return e.toString();
  }).join("\n\n"), "\n");
};
/* eslint-disable no-await-in-loop */

/**
 * Retry function call
 * @param fn - The function to be called
 * @param options - The options object
 * @param options.times - Total amount of function calls. First function call is included.
 * @param options.waitTime - Wait time between retries in milliseconds
 * @returns The function with retries
 */


var retry = function retry(fn, _ref) {
  var times = _ref.times,
      waitTime = _ref.waitTime;
  return /*#__PURE__*/(0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
    var errors,
        i,
        _args = arguments;
    return regenerator_default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            errors = [];
            i = 0;

          case 2:
            if (!(i < times)) {
              _context.next = 19;
              break;
            }

            _context.prev = 3;
            _context.next = 6;
            return fn.apply(void 0, _args);

          case 6:
            return _context.abrupt("return", _context.sent);

          case 9:
            _context.prev = 9;
            _context.t0 = _context["catch"](3);
            console.log(functionFailedText(i));

            if (!(i + 1 < times)) {
              _context.next = 15;
              break;
            }

            _context.next = 15;
            return wait(waitTime);

          case 15:
            errors.push(_context.t0);

          case 16:
            i++;
            _context.next = 2;
            break;

          case 19:
            throw new Error(allRetriesFailedText(times, errors));

          case 20:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[3, 9]]);
  }));
};
/* eslint-enable no-await-in-loop */


/* harmony default export */ var retry_retry = (retry);
;// CONCATENATED MODULE: ../../libs/utils/retry/index.ts

;// CONCATENATED MODULE: ../../libs/api/staticSiteBackend/client.ts
/* provided dependency */ var process = __webpack_require__(34406);



var OMIT_CACHE_PARAMETER = "omitCache";
var CONTENT_PREVIEW_PARAMETER = "contentPreview";

var isCacheDisabled = function isCacheDisabled() {
  return process.env.CI;
};

var createClient = function createClient() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$retry = _ref.retry,
      retryOptions = _ref$retry === void 0 ? {
    times: 3,
    waitTime: 1000
  } : _ref$retry;

  function get(_x, _x2) {
    return _get.apply(this, arguments);
  }

  function _get() {
    _get = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(url, options) {
      var fullUserUrl, fullUrl, isOmitCacheParamMissing, startTime, response, json, endTime, requestTime;
      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!url.startsWith("/")) {
                _context.next = 20;
                break;
              }

              fullUserUrl = "".concat("https://segment.com/backend").concat(url);
              fullUrl = new URL(fullUserUrl);
              isOmitCacheParamMissing = !fullUrl.searchParams.has(OMIT_CACHE_PARAMETER);

              if (isOmitCacheParamMissing && isCacheDisabled()) {
                fullUrl.searchParams.append(OMIT_CACHE_PARAMETER, "");
              }

              if (process.env.IS_CONTENTFUL_PREVIEW_BRANCH === "true") {
                fullUrl.searchParams.append(CONTENT_PREVIEW_PARAMETER, "true");
              }

              startTime = Date.now();
              _context.next = 9;
              return fetch(fullUrl.toString(), options);

            case 9:
              response = _context.sent;

              if (!response.ok) {
                _context.next = 17;
                break;
              }

              _context.next = 13;
              return response.json();

            case 13:
              json = _context.sent;

              if (!(options !== null && options !== void 0 && options.responseHeaders)) {
                _context.next = 16;
                break;
              }

              return _context.abrupt("return", {
                data: json,
                headers: response.headers
              });

            case 16:
              return _context.abrupt("return", json);

            case 17:
              endTime = Date.now();
              requestTime = (endTime - startTime) / 1000;
              throw new Error("HTTP error ".concat(response.status, ": ").concat(response.statusText, "\nwhile trying to fetch: ").concat(fullUrl, "\nresponse returned after: ").concat(requestTime, " seconds\n      "));

            case 20:
              throw new Error("Client supports only absolute paths (starting with /)");

            case 21:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    return _get.apply(this, arguments);
  }

  var retryGet = retry_retry(get, retryOptions);
  return {
    get: retryGet
  };
};



/***/ }),

/***/ 61157:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T3": function() { return /* binding */ fetchUserExists; },
/* harmony export */   "dI": function() { return /* binding */ fetchSignup; },
/* harmony export */   "oH": function() { return /* binding */ checkPassword; }
/* harmony export */ });
/* harmony import */ var _workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95235);
/* harmony import */ var _workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(20406);
/* harmony import */ var _workdir_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(28526);
/* harmony import */ var _workdir_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_workdir_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var recaptcha_v3__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7482);
/* harmony import */ var _segment_tracking_scripts__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(17397);



function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,_workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}




var fetchUserExists = /*#__PURE__*/function () {
  var _ref = (0,_workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)( /*#__PURE__*/_workdir_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().mark(function _callee(signal, email) {
    var errorMessage, response;
    return _workdir_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            errorMessage = "Error trying to fech user email";
            _context.prev = 1;
            _context.next = 4;
            return fetch("".concat((0,_segment_tracking_scripts__WEBPACK_IMPORTED_MODULE_3__/* .getBackendHost */ .kI)(window.location.host, window.location.protocol), "/backend/signup/currentUserCheck"), {
              method: "POST",
              headers: {
                'Content-Type': "application/json"
              },
              body: JSON.stringify({
                email: email
              }),
              signal: signal
            }).then(function (res) {
              return res.json();
            })["catch"](function () {
              return {
                error: errorMessage
              };
            });

          case 4:
            response = _context.sent;
            return _context.abrupt("return", response);

          case 8:
            _context.prev = 8;
            _context.t0 = _context["catch"](1);
            console.log(_context.t0);

          case 11:
            return _context.abrupt("return", {
              error: errorMessage
            });

          case 12:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[1, 8]]);
  }));

  return function fetchUserExists(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();
/**
 * Send form data to gateway api and perform signup for user.
 * @param email user email
 * @returns success or error message from server
 */

var fetchSignup = /*#__PURE__*/function () {
  var _ref2 = (0,_workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)( /*#__PURE__*/_workdir_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().mark(function _callee2(signal, formData) {
    var env, topLevel, errorMessage, recaptchaClientKey, recaptcha, recaptchaToken, response, redirectUrl, message;
    return _workdir_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            env = "production";
            topLevel = env && env !== "staging" ? "com" : "build";
            errorMessage = "Error trying to signup";
            _context2.prev = 3; // Get recaptcha token for posting to `segment-site-backend`.
            // See https://developers.google.com/recaptcha/docs/v3 for more info.

            recaptchaClientKey = "6Ld9bHgmAAAAAPEt_xy7j9cFx2RxcH0ZomV8q871" || 0;
            _context2.next = 7;
            return (0,recaptcha_v3__WEBPACK_IMPORTED_MODULE_2__/* .load */ .zD)(recaptchaClientKey);

          case 7:
            recaptcha = _context2.sent;
            _context2.next = 10;
            return recaptcha.execute("form");

          case 10:
            recaptchaToken = _context2.sent;
            _context2.next = 13;
            return fetch("".concat((0,_segment_tracking_scripts__WEBPACK_IMPORTED_MODULE_3__/* .getBackendHost */ .kI)(window.location.host, window.location.protocol), "/backend/signup/"), {
              method: "POST",
              headers: {
                'Content-Type': "application/json"
              },
              body: JSON.stringify(_objectSpread(_objectSpread({}, formData), {}, {
                recaptchaToken: recaptchaToken
              })),
              signal: signal
            }).then(function (res) {
              return res.json();
            })["catch"](function () {
              return {
                success: false,
                message: errorMessage
              };
            });

          case 13:
            response = _context2.sent;
            redirectUrl = response.success && "https://app.segment.".concat(topLevel, "/signup?response=").concat(response.message) || undefined;
            message = !response.success && response.message || undefined;
            return _context2.abrupt("return", {
              success: response.success,
              message: message,
              redirectUrl: redirectUrl
            });

          case 19:
            _context2.prev = 19;
            _context2.t0 = _context2["catch"](3);
            console.log(_context2.t0);

          case 22:
            return _context2.abrupt("return", {
              success: false,
              message: errorMessage
            });

          case 23:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[3, 19]]);
  }));

  return function fetchSignup(_x3, _x4) {
    return _ref2.apply(this, arguments);
  };
}();
/**
 * Password strength call.
 * Send the password to backend and return the score from it.
 * @param string password
 * @returns {PasswordStrengthResponse}
 */

var checkPassword = /*#__PURE__*/function () {
  var _ref3 = (0,_workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)( /*#__PURE__*/_workdir_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().mark(function _callee3(signal, password) {
    var pwdStrength;
    return _workdir_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.prev = 0;
            _context3.next = 3;
            return fetch("".concat((0,_segment_tracking_scripts__WEBPACK_IMPORTED_MODULE_3__/* .getBackendHost */ .kI)(window.location.host, window.location.protocol), "/backend/signup/password/strength"), {
              method: "POST",
              headers: {
                'Content-Type': "application/json"
              },
              body: JSON.stringify({
                password: password
              }),
              signal: signal
            }).then(function (res) {
              return res.json();
            });

          case 3:
            pwdStrength = _context3.sent;
            return _context3.abrupt("return", pwdStrength);

          case 7:
            _context3.prev = 7;
            _context3.t0 = _context3["catch"](0);
            throw Error("Something happened when trying to fetch password strength");

          case 10:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, null, [[0, 7]]);
  }));

  return function checkPassword(_x5, _x6) {
    return _ref3.apply(this, arguments);
  };
}();

/***/ }),

/***/ 94721:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ TextArea; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(82269);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/polished/dist/polished.esm.js + 8 modules
var polished_esm = __webpack_require__(13102);
// EXTERNAL MODULE: ../../libs/matcha/foundations/AppearanceContext/index.ts + 1 modules
var AppearanceContext = __webpack_require__(9381);
// EXTERNAL MODULE: ../../libs/matcha/components/Input/index.ts + 2 modules
var Input = __webpack_require__(94261);
// EXTERNAL MODULE: ../../libs/matcha/components/Fieldset/FieldsetContext.tsx
var FieldsetContext = __webpack_require__(83734);
// EXTERNAL MODULE: ../../libs/matcha/useDesignTokens/index.ts
var useDesignTokens = __webpack_require__(98439);
// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(28165);
// EXTERNAL MODULE: ../../libs/matcha/components/Typography/index.ts
var Typography = __webpack_require__(89533);
;// CONCATENATED MODULE: ../../libs/matcha/components/TextArea/TextArea.views.ts


function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}




var _ref2 =  true ? {
  name: "1d3w5wq",
  styles: "width:100%"
} : 0;

var Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e18ig01g3"
} : 0)("position:relative;display:grid;row-gap:8px;", function (_ref3) {
  var expanded = _ref3.expanded;
  return expanded && _ref2;
}, " ", function (_ref4) {
  var disabled = _ref4.disabled,
      disabledOpacity = _ref4.disabledOpacity;
  return disabled &&
  /*#__PURE__*/

  /*#__PURE__*/
  (0,emotion_react_browser_esm/* css */.iv)("opacity:", disabledOpacity, ";" + ( true ? "" : 0),  true ? "" : 0,  true ? "" : 0,  true ? "" : 0);
}, ";" + ( true ? "" : 0));
var Label = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Typography/* default */.Z,  true ? {
  target: "e18ig01g2"
} : 0)( true ? {
  name: "15i8qv7",
  styles: "margin:0;display:block"
} : 0);
var FieldWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e18ig01g1"
} : 0)( true ? {
  name: "1wqcgs4",
  styles: "position:relative;display:inherit"
} : 0);

var getShadowStyles = function getShadowStyles(shadowColor) {
  return shadowColor &&
  /*#__PURE__*/

  /*#__PURE__*/
  (0,emotion_react_browser_esm/* css */.iv)("box-shadow:0px 0px 0px 1px ", shadowColor, ";" + ( true ? "" : 0),  true ? "" : 0,  true ? "" : 0,  true ? "" : 0);
};

var _ref =  true ? {
  name: "utehjx",
  styles: "resize:none"
} : 0;

var Field = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("textarea",  true ? {
  target: "e18ig01g0"
} : 0)(function (_ref5) {
  var theme = _ref5.theme;
  return theme.typography.formInput.css;
}, ";padding:17px 20px 17px 20px;border:1px solid transparent;border-radius:5px;outline:none;transition:border-color 0.3s,background 0.3s;width:100%;padding-right:", function (_ref6) {
  var error = _ref6.error;
  return error ? "45px" : "";
}, ";::-webkit-search-decoration,::-webkit-search-cancel-button,::-webkit-search-results-button,::-webkit-search-results-decoration{-webkit-appearance:none;}appearance:none;", function (_ref7) {
  var maxWidth = _ref7.maxWidth;
  return maxWidth &&
  /*#__PURE__*/

  /*#__PURE__*/
  (0,emotion_react_browser_esm/* css */.iv)("max-width:", maxWidth, ";" + ( true ? "" : 0),  true ? "" : 0,  true ? "" : 0,  true ? "" : 0);
}, " ", function (_ref8) {
  var maxHeight = _ref8.maxHeight;
  return maxHeight &&
  /*#__PURE__*/

  /*#__PURE__*/
  (0,emotion_react_browser_esm/* css */.iv)("max-height:", maxHeight, ";" + ( true ? "" : 0),  true ? "" : 0,  true ? "" : 0,  true ? "" : 0);
}, " ", function (_ref9) {
  var noResize = _ref9.noResize;
  return noResize && _ref;
}, " background-color:", function (_ref10) {
  var backgroundColor = _ref10.backgroundColor;
  return backgroundColor;
}, ";border-color:", function (_ref11) {
  var borderColor = _ref11.borderColor;
  return borderColor;
}, ";color:", function (_ref12) {
  var color = _ref12.color;
  return color;
}, ";", function (_ref13) {
  var shadowColor = _ref13.shadowColor;
  return getShadowStyles(shadowColor);
}, ";::placeholder{color:", function (_ref14) {
  var placeholderColor = _ref14.placeholderColor;
  return placeholderColor;
}, ";opacity:", function (_ref15) {
  var placeholderOpacity = _ref15.placeholderOpacity;
  return placeholderOpacity;
}, ";}:not(:disabled):hover{background-color:", function (_ref16) {
  var hoverBackgroundColor = _ref16.hoverBackgroundColor;
  return hoverBackgroundColor;
}, ";border-color:", function (_ref17) {
  var hoverBorderColor = _ref17.hoverBorderColor;
  return hoverBorderColor;
}, ";", function (_ref18) {
  var hoverShadowColor = _ref18.hoverShadowColor;
  return getShadowStyles(hoverShadowColor);
}, ";}:focus,:focus:hover{border-color:", function (_ref19) {
  var focusBorderColor = _ref19.focusBorderColor;
  return focusBorderColor;
}, ";", function (_ref20) {
  var focusShadowColor = _ref20.focusShadowColor;
  return getShadowStyles(focusShadowColor);
}, ";}:disabled{border-color:", function (_ref21) {
  var disabledBorderColor = _ref21.disabledBorderColor;
  return disabledBorderColor;
}, ";}:-webkit-autofill{-webkit-box-shadow:none;-webkit-text-fill-color:", function (_ref22) {
  var color = _ref22.color;
  return color;
}, ";transition:background-color 5000s ease-in-out 0s;}" + ( true ? "" : 0));
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ../../libs/matcha/components/TextArea/TextArea.tsx


var _excluded = ["name", "id", "placeholder", "label", "errorText", "required", "error", "expanded", "onChange", "onBlur", "disabled", "appearance", "dataHook", "maxWidth", "maxHeight", "rows", "cols", "noResize", "defaultValue", "tokens"];

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}










var BaseTextArea = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var name = _ref.name,
      id = _ref.id,
      placeholder = _ref.placeholder,
      label = _ref.label,
      errorText = _ref.errorText,
      required = _ref.required,
      error = _ref.error,
      expanded = _ref.expanded,
      _onChange = _ref.onChange,
      onBlur = _ref.onBlur,
      disabled = _ref.disabled,
      appearance = _ref.appearance,
      dataHook = _ref.dataHook,
      maxWidth = _ref.maxWidth,
      maxHeight = _ref.maxHeight,
      rows = _ref.rows,
      cols = _ref.cols,
      noResize = _ref.noResize,
      defaultValue = _ref.defaultValue,
      tokens = _ref.tokens,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  var fieldRef = (0,react.useRef)(null);
  var textAreaAppearance = (0,AppearanceContext/* useAppearance */.M)(appearance);
  var fieldsetContext = (0,FieldsetContext/* useFieldset */.w)();
  var isDisabled = disabled || (fieldsetContext === null || fieldsetContext === void 0 ? void 0 : fieldsetContext.disabledFieldset);
  (0,react.useImperativeHandle)(ref, function () {
    return fieldRef.current;
  });
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AppearanceContext/* AppearanceProvider */.x, {
    appearance: textAreaAppearance,
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Wrapper, _objectSpread(_objectSpread({
      disabled: isDisabled,
      expanded: expanded
    }, tokens.wrapper), {}, {
      children: [label && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Label, {
        htmlFor: id,
        variant: "formLabel",
        tag: "label",
        tokens: tokens.label,
        children: label
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FieldWrapper, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Field, _objectSpread(_objectSpread({
          name: name,
          id: id,
          placeholder: placeholder,
          required: required,
          disabled: isDisabled,
          onChange: function onChange(event) {
            _onChange === null || _onChange === void 0 ? void 0 : _onChange(event, event.target.value);
          },
          error: error,
          ref: fieldRef,
          "aria-invalid": error,
          "aria-describedby": "".concat(name, "-message"),
          onBlur: onBlur,
          "data-hook": dataHook,
          maxWidth: maxWidth,
          maxHeight: maxHeight,
          rows: rows,
          cols: cols,
          defaultValue: defaultValue,
          noResize: noResize
        }, rest), tokens.field))
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Input/* ErrorSlot */.B, {
        inputName: name,
        errorText: errorText
      })]
    }))
  });
});
var TextArea = (0,useDesignTokens/* withDesignTokens */.Y)(BaseTextArea, function () {
  return {};
}, {
  light: function light(theme, props) {
    return {
      wrapper: {
        disabledOpacity: 0.75
      },
      label: {
        color: theme.palette.brand.darkAcai[500]
      },
      field: _objectSpread({
        color: theme.palette.brand.darkAcai[700],
        backgroundColor: theme.palette.neutrals.white[100],
        borderColor: theme.palette.brand.darkAcai[300],
        shadowColor: theme.palette.brand.darkAcai[300],
        placeholderColor: theme.palette.brand.darkAcai[500],
        placeholderOpacity: 0.7,
        hoverBackgroundColor: theme.palette.brand.darkAcai[100],
        focusBorderColor: theme.palette.brand.darkAcai[600],
        focusShadowColor: theme.palette.brand.darkAcai[600],
        disabledBorderColor: theme.palette.brand.darkAcai[300]
      }, props.error && {
        borderColor: theme.palette.status.error[200],
        shadowColor: theme.palette.status.error[200],
        hoverBorderColor: theme.palette.status.error[200],
        hoverShadowColor: theme.palette.status.error[200],
        focusBorderColor: theme.palette.status.error[200],
        focusShadowColor: theme.palette.status.error[200]
      })
    };
  },
  dark: function dark(theme, props) {
    return {
      wrapper: {
        disabledOpacity: 0.75
      },
      label: {
        color: theme.palette.neutrals.white[100]
      },
      field: _objectSpread({
        color: theme.palette.neutrals.white[100],
        backgroundColor: theme.palette.brand.darkAcai[600],
        borderColor: theme.palette.brand.darkAcai[600],
        shadowColor: theme.palette.brand.darkAcai[600],
        placeholderColor: theme.palette.brand.darkAcai[200],
        placeholderOpacity: 0.7,
        hoverBorderColor: (0,polished_esm/* transparentize */.DZ)(0.9, theme.palette.neutrals.white[100]),
        hoverShadowColor: (0,polished_esm/* transparentize */.DZ)(0.9, theme.palette.neutrals.white[100]),
        focusBorderColor: theme.palette.brand.darkAcai[300],
        focusShadowColor: theme.palette.brand.darkAcai[300],
        disabledBorderColor: theme.palette.brand.darkAcai[600]
      }, props.error && {
        borderColor: theme.palette.status.error[100],
        shadowColor: theme.palette.status.error[100],
        hoverBorderColor: theme.palette.status.error[100],
        hoverShadowColor: theme.palette.status.error[100],
        focusBorderColor: theme.palette.status.error[100],
        focusShadowColor: theme.palette.status.error[100]
      })
    };
  },
  twilioLight: function twilioLight(theme, props) {
    return {
      wrapper: {
        disabledOpacity: 0.5
      },
      label: {
        color: theme.palette.twilio.gray[80]
      },
      field: _objectSpread({
        color: theme.palette.twilio.gray[100],
        backgroundColor: theme.palette.neutrals.white[100],
        borderColor: theme.palette.twilio.gray[30],
        placeholderColor: theme.palette.twilio.gray[60],
        placeholderOpacity: 1,
        hoverBorderColor: theme.palette.twilio.gray[60],
        focusBorderColor: theme.palette.twilio.gray[60],
        focusShadowColor: theme.palette.twilio.gray[60],
        disabledBorderColor: theme.palette.twilio.gray[30]
      }, props.error && {
        borderColor: theme.palette.status.error[200],
        shadowColor: theme.palette.status.error[200],
        hoverBorderColor: theme.palette.status.error[200],
        hoverShadowColor: theme.palette.status.error[200],
        focusBorderColor: theme.palette.status.error[200],
        focusShadowColor: theme.palette.status.error[200]
      })
    };
  }
});
;// CONCATENATED MODULE: ../../libs/matcha/components/TextArea/index.ts


/***/ }),

/***/ 12459:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ companyEmailMessages; },
/* harmony export */   "O": function() { return /* binding */ CompanyEmailField; }
/* harmony export */ });
/* harmony import */ var _workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95235);
/* harmony import */ var _workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(20406);
/* harmony import */ var _workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(82269);
/* harmony import */ var _workdir_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(28526);
/* harmony import */ var _workdir_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_workdir_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2784);
/* harmony import */ var react_hook_form__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(63955);
/* harmony import */ var _segment_matcha_components_Input__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(94261);
/* harmony import */ var _segment_utils_regexes_email__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(36219);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(52903);



var _excluded = ["type", "name", "id", "placeholder", "label", "className", "dataHook", "onValidate", "onBlur"];

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,_workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}


/* eslint-disable react-hooks/exhaustive-deps */






var companyEmailMessages = {
  required: "Please provide your company email address.",
  invalid: "Please enter a valid email address.",
  sharedEmail: "Please provide an individual corporate email address.",
  forbiddenEmail: "Please enter a valid business email address."
};

var getUrlParameter = function getUrlParameter(name) {
  if (false) {}
  name = name.replace(/[[]/, "\\[").replace(/[\]]/, "\\]");
  var regex = new RegExp("[\\?&]" + name + "=([^&#]*)");
  var results = regex.exec(window.location.search);
  return results === null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
}; // Email decoding utility, stolen from https://github.com/segmentio/publix/blob/5c12bad05990ea314567bcf5083c0548184bf1a7/src/apps/v2/lib/Util.ts#L1.
// Note that this utility does not decode Unicode properly.


var decodeEmail = function decodeEmail(hash) {
  try {
    return atob(decodeURIComponent(hash));
  } catch (e) {
    console.error("Failed to decode \"" + hash + "\":", e);
  }

  return hash;
};
/**
 * Email input
 */


var CompanyEmailField = function CompanyEmailField(_ref) {
  var _errors$name;

  var _ref$type = _ref.type,
      type = _ref$type === void 0 ? "email" : _ref$type,
      _ref$name = _ref.name,
      name = _ref$name === void 0 ? "email" : _ref$name,
      _ref$id = _ref.id,
      id = _ref$id === void 0 ? "email" : _ref$id,
      _ref$placeholder = _ref.placeholder,
      placeholder = _ref$placeholder === void 0 ? "Your work email" : _ref$placeholder,
      label = _ref.label,
      className = _ref.className,
      dataHook = _ref.dataHook,
      onValidate = _ref.onValidate,
      _onBlur = _ref.onBlur,
      rest = (0,_workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_ref, _excluded);

  var _useFormContext = (0,react_hook_form__WEBPACK_IMPORTED_MODULE_5__/* .useFormContext */ .Gc)(),
      register = _useFormContext.register,
      trigger = _useFormContext.trigger,
      setError = _useFormContext.setError,
      errors = _useFormContext.formState.errors; // Pre-populate field from encoded param if applicable


  var decodedEmail = "";
  var emailParam = getUrlParameter("email");

  if (emailParam) {
    decodedEmail = decodeEmail(emailParam);
  }

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(_segment_utils_regexes_email__WEBPACK_IMPORTED_MODULE_6__/* ["default"].test */ .Z.test(decodedEmail)),
      valid = _useState[0],
      setValid = _useState[1];

  var _useState2 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false),
      isLoading = _useState2[0],
      setIsLoading = _useState2[1];

  var handleValidation = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)( /*#__PURE__*/function () {
    var _ref2 = (0,_workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)( /*#__PURE__*/_workdir_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().mark(function _callee(value) {
      var emailValue, validatorResponse, isResponseValid, validator;
      return _workdir_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              emailValue = value.trim();
              validatorResponse = {
                valid: true,
                message: ""
              };
              isResponseValid = _segment_utils_regexes_email__WEBPACK_IMPORTED_MODULE_6__/* ["default"].test */ .Z.test(emailValue);

              if (!(typeof onValidate === "function")) {
                _context.next = 12;
                break;
              }

              setIsLoading(true);
              _context.next = 7;
              return onValidate(emailValue);

            case 7:
              validator = _context.sent;
              validatorResponse.valid = validator.valid;
              validatorResponse.message = validator.message;
              isResponseValid = validatorResponse.valid;
              setIsLoading(false);

            case 12:
              setValid(isResponseValid);

              if (!isResponseValid) {
                setError(name, {
                  type: "validate",
                  message: validatorResponse.message
                });
              }

            case 14:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref2.apply(this, arguments);
    };
  }(), [onValidate]);
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(_segment_matcha_components_Input__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, _objectSpread(_objectSpread({
    className: className,
    id: id,
    placeholder: placeholder,
    label: label,
    type: type,
    "aria-label": placeholder,
    error: Boolean(errors[name]),
    showValidState: valid && Boolean(!errors[name]),
    errorText: (_errors$name = errors[name]) === null || _errors$name === void 0 ? void 0 : _errors$name.message,
    expanded: true,
    value: decodedEmail,
    "data-hook": dataHook,
    onAutoFill: function onAutoFill(value) {
      handleValidation(value);
      trigger(name);
    },
    isLoading: isLoading
  }, register(name, {
    required: companyEmailMessages.required,
    pattern: {
      value: _segment_utils_regexes_email__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z,
      message: companyEmailMessages.invalid
    },
    onBlur: function onBlur(e) {
      trigger(name);
      handleValidation(e.target.value);
      if (_onBlur && !valid && Object.hasOwn(errors, name)) _onBlur(errors);
    }
  })), rest));
};

/***/ }),

/***/ 10852:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CZ": function() { return /* binding */ companyJobTitleMessages; },
/* harmony export */   "t1": function() { return /* binding */ CompanyJobTitleField; }
/* harmony export */ });
/* harmony import */ var _workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95235);
/* harmony import */ var _workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(82269);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var react_hook_form__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(63955);
/* harmony import */ var _segment_matcha_components_Input__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94261);
/* harmony import */ var _segment_utils_regexes_name__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(11703);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(52903);


var _excluded = ["type", "name", "id", "placeholder", "className", "dataHook"];

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,_workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}






var companyJobTitleMessages = {
  required: "Please provide your job title.",
  invalid: "Please provide a valid job title."
};
var CompanyJobTitleField = function CompanyJobTitleField(_ref) {
  var _errors$name;

  var _ref$type = _ref.type,
      type = _ref$type === void 0 ? "text" : _ref$type,
      _ref$name = _ref.name,
      name = _ref$name === void 0 ? "companyJobTitle" : _ref$name,
      _ref$id = _ref.id,
      id = _ref$id === void 0 ? "companyJobTitle" : _ref$id,
      _ref$placeholder = _ref.placeholder,
      placeholder = _ref$placeholder === void 0 ? "Title (e.g. Senior Product Manager)" : _ref$placeholder,
      className = _ref.className,
      dataHook = _ref.dataHook,
      rest = (0,_workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_ref, _excluded);

  var _useFormContext = (0,react_hook_form__WEBPACK_IMPORTED_MODULE_4__/* .useFormContext */ .Gc)(),
      register = _useFormContext.register,
      trigger = _useFormContext.trigger,
      errors = _useFormContext.formState.errors;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false),
      valid = _useState[0],
      setValid = _useState[1];

  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_segment_matcha_components_Input__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, _objectSpread(_objectSpread({
    className: className,
    id: id,
    placeholder: placeholder,
    type: type,
    "aria-label": placeholder,
    error: Boolean(errors[name]),
    showValidState: valid && Boolean(!errors[name]),
    errorText: (_errors$name = errors[name]) === null || _errors$name === void 0 ? void 0 : _errors$name.message,
    expanded: true,
    "data-hook": dataHook,
    onAutoFill: function onAutoFill(value) {
      setValid(_segment_utils_regexes_name__WEBPACK_IMPORTED_MODULE_6__/* ["default"].test */ .Z.test(value));
      trigger("companyJobTitle");
    }
  }, register(name, {
    required: companyJobTitleMessages.required,
    onBlur: function onBlur(e) {
      setValid(_segment_utils_regexes_name__WEBPACK_IMPORTED_MODULE_6__/* ["default"].test */ .Z.test(e.target.value));
    }
  })), rest));
};
/* harmony default export */ __webpack_exports__["ZP"] = (CompanyJobTitleField);

/***/ }),

/***/ 20417:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BQ": function() { return /* binding */ CompanySizeSelectField; },
/* harmony export */   "CF": function() { return /* binding */ companySizeMessages; }
/* harmony export */ });
/* harmony import */ var _workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(95235);
/* harmony import */ var _workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(82269);
/* harmony import */ var _emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92952);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2784);
/* harmony import */ var react_hook_form__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(63955);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(28543);
/* harmony import */ var _segment_matcha_foundations_AppearanceContext__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9381);
/* harmony import */ var _segment_matcha_components_Input__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(94261);
/* harmony import */ var _segment_matcha_components_Icons_Common__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(6580);
/* harmony import */ var _segment_matcha_components_Select_useSelect__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(27431);
/* harmony import */ var _segment_matcha_components_Select__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(44502);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(52903);



var _excluded = ["name", "id", "placeholder", "label", "dataHook"];

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,_workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}











var companySizeMessages = {
  required: "Please provide a company size.",
  invalid: "Please provide a company size."
};
var options = [{
  value: "under250",
  text: "1 - 249"
}, {
  value: "between250and999",
  text: "250 - 999"
}, {
  value: "between1000and4999",
  text: "1,000 - 4,999"
}, {
  value: "over5000",
  text: "5,000+"
}];
/**
 * Company size select
 */

var CompanySizeSelectField = function CompanySizeSelectField(_ref) {
  var _errors$name;

  var _ref$name = _ref.name,
      name = _ref$name === void 0 ? "companySize" : _ref$name,
      _ref$id = _ref.id,
      id = _ref$id === void 0 ? "companySize" : _ref$id,
      _ref$placeholder = _ref.placeholder,
      placeholder = _ref$placeholder === void 0 ? "Select one" : _ref$placeholder,
      _ref$label = _ref.label,
      label = _ref$label === void 0 ? "What is the size of your company?" : _ref$label,
      _ref$dataHook = _ref.dataHook,
      dataHook = _ref$dataHook === void 0 ? "companySize" : _ref$dataHook,
      rest = (0,_workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_ref, _excluded);

  var theme = (0,_emotion_react__WEBPACK_IMPORTED_MODULE_9__.u)();
  var appearance = (0,_segment_matcha_foundations_AppearanceContext__WEBPACK_IMPORTED_MODULE_3__/* .useAppearance */ .M)();
  var iconColor = appearance === "dark" ? theme.palette.neutrals.white[100] : theme.palette.twilio.gray[80];

  var _useFormContext = (0,react_hook_form__WEBPACK_IMPORTED_MODULE_10__/* .useFormContext */ .Gc)(),
      register = _useFormContext.register,
      setValue = _useFormContext.setValue,
      errors = _useFormContext.formState.errors,
      clearErrors = _useFormContext.clearErrors;

  var _useSelect = (0,_segment_matcha_components_Select_useSelect__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
    options: options,
    id: id,
    onSelect: function onSelect() {
      setValue(name, state.selected[0].text);
      setValid(true);
      clearErrors(name);
    },
    appearance: "dark"
  }),
      state = _useSelect.state,
      getControlProps = _useSelect.getControlProps,
      filteredOptions = _useSelect.filteredOptions,
      getSelectProps = _useSelect.getSelectProps;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false),
      valid = _useState[0],
      setValid = _useState[1];

  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__/* .jsxs */ .BX)(Wrapper, {
    children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__/* .jsx */ .tZ)(_segment_matcha_components_Input__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, _objectSpread(_objectSpread(_objectSpread({
      id: id,
      type: "search",
      label: label,
      error: Boolean(errors[name]),
      showValidState: valid && Boolean(!errors[name]),
      errorText: (_errors$name = errors[name]) === null || _errors$name === void 0 ? void 0 : _errors$name.message,
      resetable: state.filterValue !== "",
      rightSecondIcon: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__/* .jsx */ .tZ)(_segment_matcha_components_Icons_Common__WEBPACK_IMPORTED_MODULE_5__/* .ChevronDownIcon */ .v4, {
        color: iconColor
      }),
      "data-testid": dataHook
    }, register(name, {
      required: companySizeMessages.required,
      onBlur: function onBlur(e) {
        setValid(Boolean(e.target.value));
      }
    })), getControlProps({
      placeholder: placeholder
    })), rest)), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__/* .jsx */ .tZ)(SelectWrapper, {
      children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__/* .jsx */ .tZ)(_segment_matcha_components_Select__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP, _objectSpread({
        id: "".concat(id, "Select"),
        name: name,
        options: options,
        filteredOptions: filteredOptions,
        displayMode: state.displayMode,
        open: state.open
      }, getSelectProps()))
    })]
  });
};

var Wrapper = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("div",  true ? {
  target: "e1jku1en1"
} : 0)( true ? {
  name: "bjn8wh",
  styles: "position:relative"
} : 0);

var SelectWrapper = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("div",  true ? {
  target: "e1jku1en0"
} : 0)( true ? {
  name: "10k07g3",
  styles: "position:relative;z-index:3"
} : 0);

/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (CompanySizeSelectField)));

/***/ }),

/***/ 43352:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ FullNameField; },
/* harmony export */   "a": function() { return /* binding */ fullNameMessages; }
/* harmony export */ });
/* harmony import */ var _workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95235);
/* harmony import */ var _workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(82269);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var react_hook_form__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(63955);
/* harmony import */ var _segment_matcha_components_Input__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94261);
/* harmony import */ var _segment_utils_regexes_name__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(11703);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(52903);


var _excluded = ["type", "name", "id", "placeholder", "className", "dataHook", "onBlur"];

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,_workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}






var fullNameMessages = {
  required: "Please provide your full name.",
  invalid: "Please provide a valid full name."
};
/**
 * Full name input
 */

var FullNameField = function FullNameField(_ref) {
  var _errors$name;

  var _ref$type = _ref.type,
      type = _ref$type === void 0 ? "text" : _ref$type,
      _ref$name = _ref.name,
      name = _ref$name === void 0 ? "name" : _ref$name,
      _ref$id = _ref.id,
      id = _ref$id === void 0 ? "name" : _ref$id,
      _ref$placeholder = _ref.placeholder,
      placeholder = _ref$placeholder === void 0 ? "Full name" : _ref$placeholder,
      className = _ref.className,
      dataHook = _ref.dataHook,
      onBlur = _ref.onBlur,
      rest = (0,_workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_ref, _excluded);

  var _useFormContext = (0,react_hook_form__WEBPACK_IMPORTED_MODULE_4__/* .useFormContext */ .Gc)(),
      register = _useFormContext.register,
      trigger = _useFormContext.trigger,
      setError = _useFormContext.setError,
      errors = _useFormContext.formState.errors;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false),
      valid = _useState[0],
      setValid = _useState[1];

  var handleValidation = function handleValidation(value) {
    setValid(_segment_utils_regexes_name__WEBPACK_IMPORTED_MODULE_5__/* ["default"].test */ .Z.test(value));

    if (!valid) {
      setError(name, {
        message: fullNameMessages.invalid,
        type: "validate"
      });
      if (onBlur && Object.hasOwn(errors, name)) onBlur(errors);
    }
  };

  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_segment_matcha_components_Input__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, _objectSpread(_objectSpread({
    className: className,
    id: id,
    placeholder: placeholder,
    type: type,
    "aria-label": placeholder,
    error: Boolean(errors[name]),
    showValidState: valid && Boolean(!errors[name]),
    errorText: (_errors$name = errors[name]) === null || _errors$name === void 0 ? void 0 : _errors$name.message,
    expanded: true,
    "data-hook": dataHook,
    onAutoFill: function onAutoFill(value) {
      setValid(_segment_utils_regexes_name__WEBPACK_IMPORTED_MODULE_5__/* ["default"].test */ .Z.test(value));
      trigger(name);
    }
  }, register(name, {
    required: fullNameMessages.required,
    validate: function validate(value) {
      return _segment_utils_regexes_name__WEBPACK_IMPORTED_MODULE_5__/* ["default"].test */ .Z.test(value) || fullNameMessages.invalid;
    },
    onBlur: function onBlur(e) {
      trigger(name);
      handleValidation(e.target.value);
    }
  })), rest));
};

/***/ }),

/***/ 96321:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "cY": function() { return /* binding */ jobTitleMessages; },
/* harmony export */   "kL": function() { return /* binding */ JobTitleField; }
/* harmony export */ });
/* harmony import */ var _workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95235);
/* harmony import */ var _workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(20406);
/* harmony import */ var _workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(82269);
/* harmony import */ var _workdir_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(28526);
/* harmony import */ var _workdir_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_workdir_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2784);
/* harmony import */ var react_hook_form__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(63955);
/* harmony import */ var _segment_matcha_components_Input__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(94261);
/* harmony import */ var _segment_utils_regexes_form__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(63535);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(52903);



var _excluded = ["type", "name", "id", "placeholder", "label", "className", "dataHook", "onValidate", "onBlur"];

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,_workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}


/* eslint-disable react-hooks/exhaustive-deps */






var jobTitleMessages = {
  required: "Please provide your job title.",
  invalid: "Please provide a valid job title."
};
var JobTitleField = function JobTitleField(_ref) {
  var _errors$name;

  var _ref$type = _ref.type,
      type = _ref$type === void 0 ? "text" : _ref$type,
      _ref$name = _ref.name,
      name = _ref$name === void 0 ? "jobTitle" : _ref$name,
      _ref$id = _ref.id,
      id = _ref$id === void 0 ? "jobTitle" : _ref$id,
      _ref$placeholder = _ref.placeholder,
      placeholder = _ref$placeholder === void 0 ? "Job title" : _ref$placeholder,
      _ref$label = _ref.label,
      label = _ref$label === void 0 ? "What is your job title?" : _ref$label,
      className = _ref.className,
      dataHook = _ref.dataHook,
      onValidate = _ref.onValidate,
      _onBlur = _ref.onBlur,
      rest = (0,_workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_ref, _excluded);

  var _useFormContext = (0,react_hook_form__WEBPACK_IMPORTED_MODULE_5__/* .useFormContext */ .Gc)(),
      register = _useFormContext.register,
      trigger = _useFormContext.trigger,
      setError = _useFormContext.setError,
      errors = _useFormContext.formState.errors;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false),
      valid = _useState[0],
      setValid = _useState[1];

  var _useState2 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false),
      isLoading = _useState2[0],
      setIsLoading = _useState2[1];

  var handleValidation = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)( /*#__PURE__*/function () {
    var _ref2 = (0,_workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)( /*#__PURE__*/_workdir_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().mark(function _callee(value) {
      var jobTitleValue, validatorResponse, isResponseValid, validator;
      return _workdir_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              jobTitleValue = value.trim();
              validatorResponse = {
                valid: true,
                message: ""
              };
              isResponseValid = _segment_utils_regexes_form__WEBPACK_IMPORTED_MODULE_7__/* ["default"].test */ .Z.test(jobTitleValue);

              if (!(typeof onValidate === "function")) {
                _context.next = 12;
                break;
              }

              setIsLoading(true);
              _context.next = 7;
              return onValidate(jobTitleValue);

            case 7:
              validator = _context.sent;
              validatorResponse.valid = validator.valid;
              validatorResponse.message = validator.message;
              isResponseValid = validatorResponse.valid;
              setIsLoading(false);

            case 12:
              setValid(isResponseValid);

              if (!isResponseValid) {
                setError(name, {
                  type: "validate",
                  message: validatorResponse.message
                });
              }

            case 14:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref2.apply(this, arguments);
    };
  }(), [onValidate]);
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(_segment_matcha_components_Input__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, _objectSpread(_objectSpread({
    className: className,
    id: id,
    placeholder: placeholder,
    label: label,
    type: type,
    "aria-label": placeholder,
    error: Boolean(errors[name]),
    showValidState: valid && Boolean(!errors[name]),
    errorText: (_errors$name = errors[name]) === null || _errors$name === void 0 ? void 0 : _errors$name.message,
    expanded: true,
    "data-hook": dataHook,
    onAutoFill: function onAutoFill(value) {
      setValid(_segment_utils_regexes_form__WEBPACK_IMPORTED_MODULE_7__/* ["default"].test */ .Z.test(value));
      trigger(name);
    },
    isLoading: isLoading
  }, register(name, {
    required: jobTitleMessages.required,
    pattern: {
      value: _segment_utils_regexes_form__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z,
      message: jobTitleMessages.invalid
    },
    onBlur: function onBlur(e) {
      trigger(name);
      handleValidation(e.target.value);
      if (_onBlur && !valid && Object.hasOwn(errors, name)) _onBlur(errors);
    }
  })), rest));
};
/* harmony default export */ __webpack_exports__["ZP"] = (JobTitleField);

/***/ }),

/***/ 75886:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "VW": function() { return /* binding */ MonthlyTrafficSelectField; },
/* harmony export */   "dn": function() { return /* binding */ monthlyTrafficMessages; }
/* harmony export */ });
/* harmony import */ var _workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(95235);
/* harmony import */ var _workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(82269);
/* harmony import */ var _emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92952);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2784);
/* harmony import */ var react_hook_form__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(63955);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(28543);
/* harmony import */ var _segment_matcha_foundations_AppearanceContext__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9381);
/* harmony import */ var _segment_matcha_components_Input__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(94261);
/* harmony import */ var _segment_matcha_components_Icons_Common__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(6580);
/* harmony import */ var _segment_matcha_components_Select_useSelect__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(27431);
/* harmony import */ var _segment_matcha_components_Select__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(44502);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(52903);



var _excluded = ["name", "id", "placeholder", "label", "dataHook"];

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,_workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}











var monthlyTrafficMessages = {
  required: "Please provide the estimated web traffic.",
  invalid: "Please provide the estimated web traffic."
};
var options = [{
  value: "notSure",
  text: "I\u2019m not sure"
}, {
  value: "lessThan1000",
  text: "1 - 999 users/mo"
}, {
  value: "lessThan10000",
  text: "1,000 - 9,999 users/mo"
}, {
  value: "over10000",
  text: "10,000+ users/mo"
}];
/**
 * Company size select
 */

var MonthlyTrafficSelectField = function MonthlyTrafficSelectField(_ref) {
  var _errors$name;

  var _ref$name = _ref.name,
      name = _ref$name === void 0 ? "monthlyTraffic" : _ref$name,
      _ref$id = _ref.id,
      id = _ref$id === void 0 ? "monthlyTraffic" : _ref$id,
      _ref$placeholder = _ref.placeholder,
      placeholder = _ref$placeholder === void 0 ? "Select one" : _ref$placeholder,
      _ref$label = _ref.label,
      label = _ref$label === void 0 ? "What is the estimated monthly traffic to your company website?" : _ref$label,
      _ref$dataHook = _ref.dataHook,
      dataHook = _ref$dataHook === void 0 ? "monthlyTraffic" : _ref$dataHook,
      rest = (0,_workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_ref, _excluded);

  var theme = (0,_emotion_react__WEBPACK_IMPORTED_MODULE_9__.u)();
  var appearance = (0,_segment_matcha_foundations_AppearanceContext__WEBPACK_IMPORTED_MODULE_3__/* .useAppearance */ .M)();
  var iconColor = appearance === "dark" ? theme.palette.neutrals.white[100] : theme.palette.twilio.gray[80];

  var _useFormContext = (0,react_hook_form__WEBPACK_IMPORTED_MODULE_10__/* .useFormContext */ .Gc)(),
      register = _useFormContext.register,
      setValue = _useFormContext.setValue,
      errors = _useFormContext.formState.errors,
      clearErrors = _useFormContext.clearErrors;

  var _useSelect = (0,_segment_matcha_components_Select_useSelect__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
    options: options,
    id: id,
    onSelect: function onSelect() {
      setValue(name, state.selected[0].text);
      setValid(true);
      clearErrors(name);
    },
    appearance: "dark"
  }),
      state = _useSelect.state,
      getControlProps = _useSelect.getControlProps,
      filteredOptions = _useSelect.filteredOptions,
      getSelectProps = _useSelect.getSelectProps;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false),
      valid = _useState[0],
      setValid = _useState[1];

  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__/* .jsxs */ .BX)(Wrapper, {
    children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__/* .jsx */ .tZ)(_segment_matcha_components_Input__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, _objectSpread(_objectSpread(_objectSpread({
      id: id,
      type: "search",
      label: label,
      error: Boolean(errors[name]),
      showValidState: valid && Boolean(!errors[name]),
      errorText: (_errors$name = errors[name]) === null || _errors$name === void 0 ? void 0 : _errors$name.message,
      resetable: state.filterValue !== "",
      rightSecondIcon: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__/* .jsx */ .tZ)(_segment_matcha_components_Icons_Common__WEBPACK_IMPORTED_MODULE_5__/* .ChevronDownIcon */ .v4, {
        color: iconColor
      }),
      "data-testid": dataHook
    }, register(name, {
      required: monthlyTrafficMessages.required,
      onBlur: function onBlur(e) {
        setValid(Boolean(e.target.value));
      }
    })), getControlProps({
      placeholder: placeholder
    })), rest)), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__/* .jsx */ .tZ)(SelectWrapper, {
      children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__/* .jsx */ .tZ)(_segment_matcha_components_Select__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP, _objectSpread({
        id: "".concat(id, "Select"),
        name: name,
        options: options,
        filteredOptions: filteredOptions,
        displayMode: state.displayMode,
        open: state.open
      }, getSelectProps()))
    })]
  });
};

var Wrapper = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("div",  true ? {
  target: "e1ageot61"
} : 0)( true ? {
  name: "bjn8wh",
  styles: "position:relative"
} : 0);

var SelectWrapper = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("div",  true ? {
  target: "e1ageot60"
} : 0)( true ? {
  name: "wrqbg1",
  styles: "position:relative;z-index:2"
} : 0);

/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (MonthlyTrafficSelectField)));

/***/ }),

/***/ 12307:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Cb": function() { return /* binding */ timelineMessages; },
/* harmony export */   "fz": function() { return /* binding */ TimelineSelectField; }
/* harmony export */ });
/* harmony import */ var _workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(95235);
/* harmony import */ var _workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(82269);
/* harmony import */ var _emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92952);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2784);
/* harmony import */ var react_hook_form__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(63955);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(28543);
/* harmony import */ var _segment_matcha_foundations_AppearanceContext__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9381);
/* harmony import */ var _segment_matcha_components_Input__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(94261);
/* harmony import */ var _segment_matcha_components_Icons_Common__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(6580);
/* harmony import */ var _segment_matcha_components_Select_useSelect__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(27431);
/* harmony import */ var _segment_matcha_components_Select__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(44502);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(52903);



var _excluded = ["name", "id", "placeholder", "label", "dataHook"];

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,_workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}











var timelineMessages = {
  required: "Please provide a timeline.",
  invalid: "Please provide a timeline."
};
var options = [{
  value: "within4weeks",
  text: "Within 4 weeks"
}, {
  value: "within6months",
  text: "Within 6 months"
}, {
  value: "within1year",
  text: "Within 1 year"
}, {
  value: "noRush",
  text: "No rush"
}];
/**
 * Company size select
 */

var TimelineSelectField = function TimelineSelectField(_ref) {
  var _errors$name;

  var _ref$name = _ref.name,
      name = _ref$name === void 0 ? "timeline" : _ref$name,
      _ref$id = _ref.id,
      id = _ref$id === void 0 ? "timeline" : _ref$id,
      _ref$placeholder = _ref.placeholder,
      placeholder = _ref$placeholder === void 0 ? "Select one" : _ref$placeholder,
      _ref$label = _ref.label,
      label = _ref$label === void 0 ? "What is your rough timeline to implement a CDP?" : _ref$label,
      _ref$dataHook = _ref.dataHook,
      dataHook = _ref$dataHook === void 0 ? "timeline" : _ref$dataHook,
      rest = (0,_workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_ref, _excluded);

  var theme = (0,_emotion_react__WEBPACK_IMPORTED_MODULE_9__.u)();
  var appearance = (0,_segment_matcha_foundations_AppearanceContext__WEBPACK_IMPORTED_MODULE_3__/* .useAppearance */ .M)();
  var iconColor = appearance === "dark" ? theme.palette.neutrals.white[100] : theme.palette.twilio.gray[80];

  var _useFormContext = (0,react_hook_form__WEBPACK_IMPORTED_MODULE_10__/* .useFormContext */ .Gc)(),
      register = _useFormContext.register,
      setValue = _useFormContext.setValue,
      errors = _useFormContext.formState.errors,
      clearErrors = _useFormContext.clearErrors;

  var _useSelect = (0,_segment_matcha_components_Select_useSelect__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
    options: options,
    id: id,
    onSelect: function onSelect() {
      setValue(name, state.selected[0].text);
      setValid(true);
      clearErrors(name);
    },
    appearance: "dark"
  }),
      state = _useSelect.state,
      getControlProps = _useSelect.getControlProps,
      filteredOptions = _useSelect.filteredOptions,
      getSelectProps = _useSelect.getSelectProps;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false),
      valid = _useState[0],
      setValid = _useState[1];

  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__/* .jsxs */ .BX)(Wrapper, {
    children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__/* .jsx */ .tZ)(_segment_matcha_components_Input__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, _objectSpread(_objectSpread(_objectSpread({
      id: id,
      type: "search",
      label: label,
      error: Boolean(errors[name]),
      showValidState: valid && Boolean(!errors[name]),
      errorText: (_errors$name = errors[name]) === null || _errors$name === void 0 ? void 0 : _errors$name.message,
      resetable: state.filterValue !== "",
      rightSecondIcon: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__/* .jsx */ .tZ)(_segment_matcha_components_Icons_Common__WEBPACK_IMPORTED_MODULE_5__/* .ChevronDownIcon */ .v4, {
        color: iconColor
      }),
      "data-testid": dataHook
    }, register(name, {
      required: timelineMessages.required,
      onBlur: function onBlur(e) {
        setValid(Boolean(e.target.value));
      }
    })), getControlProps({
      placeholder: placeholder
    })), rest)), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__/* .jsx */ .tZ)(SelectWrapper, {
      children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__/* .jsx */ .tZ)(_segment_matcha_components_Select__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP, _objectSpread({
        id: "".concat(id, "Select"),
        name: name,
        options: options,
        filteredOptions: filteredOptions,
        displayMode: state.displayMode,
        open: state.open
      }, getSelectProps()))
    })]
  });
};

var Wrapper = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("div",  true ? {
  target: "e1p1ars11"
} : 0)( true ? {
  name: "bjn8wh",
  styles: "position:relative"
} : 0);

var SelectWrapper = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("div",  true ? {
  target: "e1p1ars10"
} : 0)( true ? {
  name: "179t5g5",
  styles: "position:relative;z-index:1"
} : 0);

/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (TimelineSelectField)));

/***/ }),

/***/ 53790:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "_K": function() { return /* reexport */ AddressLine; },
  "Ff": function() { return /* reexport */ City; },
  "Ot": function() { return /* reexport */ CompanyEmail/* CompanyEmailField */.O; },
  "jj": function() { return /* reexport */ CompanyJobTitle/* default */.ZP; },
  "wA": function() { return /* reexport */ CompanyNameField; },
  "Dz": function() { return /* reexport */ Country; },
  "ZN": function() { return /* reexport */ CurrentTwilioCustomer; },
  "Fe": function() { return /* reexport */ CustomFormIdentifierField; },
  "u9": function() { return /* reexport */ DetailsOfInterest; },
  "tF": function() { return /* reexport */ DetailsOfRelationship; },
  "iF": function() { return /* reexport */ FirstNameField; },
  "AM": function() { return /* reexport */ FullName/* FullNameField */.A; },
  "Xq": function() { return /* reexport */ JobTitle/* default */.ZP; },
  "c_": function() { return /* reexport */ LastNameField; },
  "xN": function() { return /* reexport */ MarketingCampaignsLead; },
  "ZI": function() { return /* reexport */ Password; },
  "g8": function() { return /* reexport */ PhoneNumberField; },
  "p": function() { return /* reexport */ PostalCode; },
  "D6": function() { return /* reexport */ SegmentWorkspaceField; },
  "QQ": function() { return /* reexport */ State; },
  "iZ": function() { return /* reexport */ TWILIO_PHONE_CALLING_COUNTRY_CODE; },
  "$l": function() { return /* reexport */ TWILIO_PHONE_COUNTRY_CODE; },
  "q5": function() { return /* reexport */ TWILIO_PHONE_ERRORS_FIELD; },
  "UN": function() { return /* reexport */ TWILIO_PHONE_NATIONAL_FORMAT; },
  "SZ": function() { return /* reexport */ TWILIO_PHONE_NUMBER; },
  "tj": function() { return /* reexport */ TWILIO_PHONE_VALID_FIELD; },
  "mp": function() { return /* reexport */ TwilioSpendLevel; },
  "iU": function() { return /* reexport */ addressLineMessages; },
  "bd": function() { return /* reexport */ cityMessages; },
  "BN": function() { return /* reexport */ CompanyEmail/* companyEmailMessages */.B; },
  "qx": function() { return /* reexport */ companyNameMessages; },
  "Cn": function() { return /* reexport */ countryMessages; },
  "AG": function() { return /* reexport */ currentTwilioCustomerMessages; },
  "Dq": function() { return /* reexport */ detailsOfInterestMessages; },
  "Kv": function() { return /* reexport */ detailsOfRelationshipMessages; },
  "OE": function() { return /* reexport */ firstNameMessages; },
  "aZ": function() { return /* reexport */ FullName/* fullNameMessages */.a; },
  "AP": function() { return /* reexport */ getPhoneErrorMessage; },
  "cY": function() { return /* reexport */ JobTitle/* jobTitleMessages */.cY; },
  "tT": function() { return /* reexport */ lastNameMessages; },
  "P5": function() { return /* reexport */ marketingCampaignsLeadMessages; },
  "NJ": function() { return /* reexport */ phoneNumberMessages; },
  "yS": function() { return /* reexport */ postalCodeMessages; },
  "ZK": function() { return /* reexport */ segmentWorkspaceMessages; },
  "_1": function() { return /* reexport */ stateMessages; },
  "mn": function() { return /* reexport */ twilioSpendLevelMessages; }
});

// UNUSED EXPORTS: CompanySize, MonthlyTraffic, TimeLine, companyJobTitleMessages, companySizeMessages, countryRegionMessages, monthlyTrafficMessages, passwordErrorMessages, timelineMessages, usePassword

// EXTERNAL MODULE: ../../libs/templates/FormFields/CompanyEmail.tsx
var CompanyEmail = __webpack_require__(12459);
// EXTERNAL MODULE: ../../libs/templates/FormFields/FullName.tsx
var FullName = __webpack_require__(43352);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(20406);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(82269);
// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(28526);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(63955);
// EXTERNAL MODULE: ../../node_modules/intl-tel-input/index.js
var intl_tel_input = __webpack_require__(66670);
var intl_tel_input_default = /*#__PURE__*/__webpack_require__.n(intl_tel_input);
// EXTERNAL MODULE: ../../node_modules/intl-tel-input/build/css/intlTelInput.css
var intlTelInput = __webpack_require__(94829);
// EXTERNAL MODULE: ../../node_modules/intl-tel-input/build/img/flags.png
var flags = __webpack_require__(1588);
var flags_default = /*#__PURE__*/__webpack_require__.n(flags);
// EXTERNAL MODULE: ../../node_modules/intl-tel-input/build/img/flags@2x.png
var flags_2x = __webpack_require__(90298);
var flags_2x_default = /*#__PURE__*/__webpack_require__.n(flags_2x);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/dist/emotion-element-6a883da9.browser.esm.js + 1 modules
var emotion_element_6a883da9_browser_esm = __webpack_require__(28543);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(28165);
// EXTERNAL MODULE: ../../libs/matcha/components/Input/index.ts + 2 modules
var Input = __webpack_require__(94261);
// EXTERNAL MODULE: ../../libs/tracking/scripts/index.ts + 2 modules
var scripts = __webpack_require__(17397);
// EXTERNAL MODULE: ../../libs/api/staticSiteBackend/client.ts + 2 modules
var staticSiteBackend_client = __webpack_require__(39896);
;// CONCATENATED MODULE: ../../libs/templates/FormFields/PhoneNumber/useTwilioPhoneValidation.ts



var useTwilioPhoneValidation = function useTwilioPhoneValidation() {
  var client = (0,staticSiteBackend_client/* createClient */.e)();

  var lookupPhone = /*#__PURE__*/function () {
    var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(phone) {
      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", client.get("/lookup/phone/".concat(phone)));

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function lookupPhone(_x) {
      return _ref.apply(this, arguments);
    };
  }();

  return {
    lookupPhone: lookupPhone
  };
};
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ../../libs/templates/FormFields/PhoneNumber/PhoneNumber.tsx




var _excluded = ["type", "name", "id", "placeholder", "className", "onValidate", "dataHook", "countryCode", "onBlur"];

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}














var phoneNumberMessages = {
  required: "Please provide your phone number.",
  invalid: "Please provide a valid phone number.",
  invalidCountryCode: "Please provide a phone number with a valid country code.",
  tooShort: "That phone number is too short.",
  tooLong: "That phone number is too long.",
  localOnly: "Please provide a valid phone number.",
  invalidLength: "Please provide a valid phone number."
};
var TWILIO_PHONE_VALID_FIELD = "twilioPhoneValid";
var TWILIO_PHONE_ERRORS_FIELD = "twilioPhoneErrors";
var TWILIO_PHONE_CALLING_COUNTRY_CODE = "callingCountryCode";
var TWILIO_PHONE_COUNTRY_CODE = "countryCode";
var TWILIO_PHONE_NUMBER = "phoneNumber";
var TWILIO_PHONE_NATIONAL_FORMAT = "nationalFormat";
var getPhoneErrorMessage = function getPhoneErrorMessage(errorCode) {
  switch (errorCode) {
    case 4:
      return phoneNumberMessages.localOnly;

    case 3:
      return phoneNumberMessages.tooLong;

    case 2:
      return phoneNumberMessages.tooShort;

    case 1:
      return phoneNumberMessages.invalidCountryCode;

    case 0:
    default:
      return phoneNumberMessages.invalid;
  }
};
/**
 * Phone number input
 */

var PhoneNumberField = function PhoneNumberField(_ref) {
  var _errors$name;

  var _ref$type = _ref.type,
      type = _ref$type === void 0 ? "tel" : _ref$type,
      _ref$name = _ref.name,
      name = _ref$name === void 0 ? "phone" : _ref$name,
      _ref$id = _ref.id,
      id = _ref$id === void 0 ? "phone" : _ref$id,
      _ref$placeholder = _ref.placeholder,
      placeholder = _ref$placeholder === void 0 ? "Phone number" : _ref$placeholder,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? "intl-tel-input" : _ref$className,
      onValidate = _ref.onValidate,
      dataHook = _ref.dataHook,
      countryCode = _ref.countryCode,
      onBlur = _ref.onBlur,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  var _useFormContext = (0,index_esm/* useFormContext */.Gc)(),
      register = _useFormContext.register,
      trigger = _useFormContext.trigger,
      setValue = _useFormContext.setValue,
      setError = _useFormContext.setError,
      errors = _useFormContext.formState.errors;

  var _useState = (0,react.useState)(null),
      iti = _useState[0],
      setIti = _useState[1];

  var _useState2 = (0,react.useState)(false),
      valid = _useState2[0],
      setValid = _useState2[1];

  var handleValidation = function handleValidation(value, isTwilioValid) {
    setValid(Boolean(value && isValidNumber() && isTwilioValid));

    if (!valid) {
      setError(name, {
        message: phoneNumberMessages.invalid,
        type: "validate"
      });
      if (onBlur && Object.hasOwn(errors, name)) onBlur(errors);
    }
  };

  var _useTwilioPhoneValida = useTwilioPhoneValidation(),
      lookupPhone = _useTwilioPhoneValida.lookupPhone;

  var theme = (0,emotion_element_6a883da9_browser_esm.u)();
  (0,react.useEffect)(function () {
    var element = document.querySelector("#".concat(id));

    if (element && countryCode) {
      // Initializing intl-tel-input plugin https://github.com/jackocnr/intl-tel-input
      setIti(intl_tel_input_default()(element, {
        hiddenInput: "intl-phone-input",
        initialCountry: "auto",
        geoIpLookup: function geoIpLookup(callback) {
          callback(countryCode);
        },
        utilsScript: "https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/18.1.0/js/utils.js"
      }));
    }
  }, [countryCode, id]);

  var isValidNumber = function isValidNumber() {
    return iti && iti.isValidNumber() || !iti;
  };

  var getErrorCode = function getErrorCode() {
    var isTwilioValid = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

    if (!isValidNumber()) {
      return iti.getValidationError();
    }

    if (!isTwilioValid) {
      return 5; // Generic error code for twilio validation.
    }
  };

  var stripDialFromPhone = function stripDialFromPhone(phone, dial) {
    var phoneNoSpaces = phone.replace(/[\s()-]/g, "");

    if (phoneNoSpaces.startsWith(dial)) {
      return phoneNoSpaces.substring(dial.length);
    }

    if (phoneNoSpaces.startsWith("+".concat(dial))) {
      return phoneNoSpaces.substring(dial.length + 1);
    }

    return phoneNoSpaces;
  };

  var validateTwilioPhone = /*#__PURE__*/function () {
    var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(phone) {
      var _data$phoneNumber, countryData, dial, fullPhoneNumber, data;

      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!phone) {
                _context.next = 20;
                break;
              }

              _context.prev = 1;
              countryData = iti === null || iti === void 0 ? void 0 : iti.getSelectedCountryData();
              dial = countryData === null || countryData === void 0 ? void 0 : countryData.dialCode;
              fullPhoneNumber = "".concat(dial ? "+".concat(dial) : "").concat(stripDialFromPhone(phone, dial));
              _context.next = 7;
              return lookupPhone(fullPhoneNumber);

            case 7:
              data = _context.sent;
              setValue(TWILIO_PHONE_VALID_FIELD, "".concat(data.valid));
              setValue(TWILIO_PHONE_ERRORS_FIELD, "".concat([data.validationErrors]));
              setValue(TWILIO_PHONE_CALLING_COUNTRY_CODE, "".concat(data.callingCountryCode));
              setValue(TWILIO_PHONE_COUNTRY_CODE, "".concat(data.countryCode));
              setValue(TWILIO_PHONE_NUMBER, "".concat((_data$phoneNumber = data.phoneNumber) === null || _data$phoneNumber === void 0 ? void 0 : _data$phoneNumber.replace("+", "")));
              setValue(TWILIO_PHONE_NATIONAL_FORMAT, "".concat(data.nationalFormat));
              return _context.abrupt("return", data.valid);

            case 17:
              _context.prev = 17;
              _context.t0 = _context["catch"](1);
              (0,scripts/* track */.j)("Twilio lookup API error", {
                type: "Phone Validation",
                error: _context.t0.message
              });

            case 20:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[1, 17]]);
    }));

    return function validateTwilioPhone(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Wrapper, {
    "data-testid": "phoneNumberField",
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_browser_esm/* Global */.xB, {
      styles: getStyles(theme)
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Input/* default */.Z, _objectSpread(_objectSpread({
      className: className,
      id: id,
      placeholder: placeholder,
      type: type,
      "aria-label": placeholder,
      error: Boolean(errors[name]),
      showValidState: valid && Boolean(!errors[name]),
      errorText: (_errors$name = errors[name]) === null || _errors$name === void 0 ? void 0 : _errors$name.message,
      expanded: true,
      "data-hook": dataHook,
      onAutoFill: /*#__PURE__*/function () {
        var _ref3 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2(value) {
          var isValidTwilioPhoneNumber;
          return regenerator_default().wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  _context2.next = 2;
                  return validateTwilioPhone(value);

                case 2:
                  isValidTwilioPhoneNumber = _context2.sent;
                  handleValidation(value, Boolean(isValidTwilioPhoneNumber));

                  if (onValidate) {
                    onValidate(getErrorCode(Boolean(isValidTwilioPhoneNumber)));
                  }

                  trigger(name);

                case 6:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2);
        }));

        return function (_x2) {
          return _ref3.apply(this, arguments);
        };
      }()
    }, register(name, {
      validate: {
        // Intl-tel-input validation error map values.
        // https://github.com/jackocnr/intl-tel-input/blob/master/src/js/utils.js#L130
        required: function required(value) {
          return value ? undefined : phoneNumberMessages.required;
        },
        possible: function possible() {
          return getErrorCode() === 0 ? phoneNumberMessages.invalid : undefined;
        },
        invalidCountryCode: function invalidCountryCode() {
          return getErrorCode() === 1 ? phoneNumberMessages.invalidCountryCode : undefined;
        },
        tooShort: function tooShort() {
          return getErrorCode() === 2 ? phoneNumberMessages.tooShort : undefined;
        },
        tooLong: function tooLong() {
          return getErrorCode() === 3 ? phoneNumberMessages.tooLong : undefined;
        },
        localOnly: function localOnly() {
          return getErrorCode() === 4 ? phoneNumberMessages.localOnly : undefined;
        }
      },
      onBlur: function onBlur(event) {
        return (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee3() {
          var isValidTwilioPhoneNumber;
          return regenerator_default().wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  _context3.next = 2;
                  return validateTwilioPhone(event.target.value);

                case 2:
                  isValidTwilioPhoneNumber = _context3.sent;
                  handleValidation(event.target.value, Boolean(isValidTwilioPhoneNumber));

                  if (onValidate) {
                    onValidate(getErrorCode(Boolean(isValidTwilioPhoneNumber)));
                  }

                  trigger(name);

                case 6:
                case "end":
                  return _context3.stop();
              }
            }
          }, _callee3);
        }))();
      }
    })), rest)), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Input/* default */.Z, _objectSpread({
      type: "hidden",
      id: TWILIO_PHONE_VALID_FIELD
    }, register(TWILIO_PHONE_VALID_FIELD))), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Input/* default */.Z, _objectSpread({
      type: "hidden",
      id: TWILIO_PHONE_ERRORS_FIELD
    }, register(TWILIO_PHONE_ERRORS_FIELD))), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Input/* default */.Z, _objectSpread({
      type: "hidden",
      id: TWILIO_PHONE_CALLING_COUNTRY_CODE
    }, register(TWILIO_PHONE_CALLING_COUNTRY_CODE))), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Input/* default */.Z, _objectSpread({
      type: "hidden",
      id: TWILIO_PHONE_COUNTRY_CODE
    }, register(TWILIO_PHONE_COUNTRY_CODE))), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Input/* default */.Z, _objectSpread({
      type: "hidden",
      id: TWILIO_PHONE_NUMBER
    }, register(TWILIO_PHONE_NUMBER))), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Input/* default */.Z, _objectSpread({
      type: "hidden",
      id: TWILIO_PHONE_NATIONAL_FORMAT
    }, register(TWILIO_PHONE_NATIONAL_FORMAT)))]
  });
};

var Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e17lsax0"
} : 0)( true ? "" : 0);

var getStyles = function getStyles(theme) {
  return (
    /*#__PURE__*/

    /*#__PURE__*/
    (0,emotion_react_browser_esm/* css */.iv)(".iti{display:block;font-family:", theme.typography.pSmall.fontFamily, ";font-size:", theme.typography.pSmall.fontSize, ";}.iti__flag{background-image:url(", (flags_default()), ");@media (-webkit-min-device-pixel-ratio: 2),(min-resolution: 192dpi){background-image:url(", (flags_2x_default()), ");}}" + ( true ? "" : 0),  true ? "" : 0,  true ? "" : 0,  true ? "" : 0)
  );
};

/* harmony default export */ var PhoneNumber = ((/* unused pure expression or super */ null && (PhoneNumberField)));
;// CONCATENATED MODULE: ../../libs/utils/regexes/companyName.ts
var companyNameRegex = /^[{\p{L}}{0-9}{!#@$%^&*+=(). -}].{1,60}$/;
/* harmony default export */ var companyName = (companyNameRegex);
;// CONCATENATED MODULE: ../../libs/templates/FormFields/CompanyName.tsx


var CompanyName_excluded = ["type", "name", "id", "placeholder", "label", "className", "dataHook", "onBlur"];

function CompanyName_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function CompanyName_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? CompanyName_ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : CompanyName_ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}






var companyNameMessages = {
  required: "Please provide your company name.",
  invalid: "Please provide a valid company name: max 60 characters, no special characters."
};
/**
 * Company name input
 */

var CompanyNameField = function CompanyNameField(_ref) {
  var _errors$name;

  var _ref$type = _ref.type,
      type = _ref$type === void 0 ? "text" : _ref$type,
      _ref$name = _ref.name,
      name = _ref$name === void 0 ? "company" : _ref$name,
      _ref$id = _ref.id,
      id = _ref$id === void 0 ? "company" : _ref$id,
      _ref$placeholder = _ref.placeholder,
      placeholder = _ref$placeholder === void 0 ? "Company name" : _ref$placeholder,
      label = _ref.label,
      className = _ref.className,
      dataHook = _ref.dataHook,
      onBlur = _ref.onBlur,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, CompanyName_excluded);

  var _useFormContext = (0,index_esm/* useFormContext */.Gc)(),
      register = _useFormContext.register,
      trigger = _useFormContext.trigger,
      setError = _useFormContext.setError,
      errors = _useFormContext.formState.errors;

  var _useState = (0,react.useState)(false),
      valid = _useState[0],
      setValid = _useState[1];

  var handleValidation = function handleValidation(value) {
    setValid(companyName.test(value));

    if (!valid) {
      setError(name, {
        message: companyNameMessages.invalid,
        type: "validate"
      });
      if (onBlur && Object.hasOwn(errors, name)) onBlur(errors);
    }
  };

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Input/* default */.Z, CompanyName_objectSpread(CompanyName_objectSpread({
    className: className,
    id: id,
    placeholder: placeholder,
    label: label,
    type: type,
    "aria-label": placeholder,
    error: Boolean(errors[name]),
    showValidState: valid && Boolean(!errors[name]),
    errorText: (_errors$name = errors[name]) === null || _errors$name === void 0 ? void 0 : _errors$name.message,
    expanded: true,
    "data-hook": dataHook,
    onAutoFill: function onAutoFill(value) {
      trigger("name");
      setValid(companyName.test(value));
    }
  }, register(name, {
    required: companyNameMessages.required,
    pattern: {
      value: companyName,
      message: companyNameMessages.invalid
    },
    onBlur: function onBlur(e) {
      trigger(name);
      handleValidation(e.target.value);
    }
  })), rest));
};
;// CONCATENATED MODULE: ../../libs/templates/FormFields/CustomFormIdentifierField.tsx


var CustomFormIdentifierField_excluded = ["type", "name", "id", "className", "dataHook", "value"];

function CustomFormIdentifierField_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function CustomFormIdentifierField_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? CustomFormIdentifierField_ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : CustomFormIdentifierField_ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}




/**
 * CustomFormIdentifierField hidden input for demo forms
 */

var CustomFormIdentifierField = function CustomFormIdentifierField(_ref) {
  var _ref$type = _ref.type,
      type = _ref$type === void 0 ? "hidden" : _ref$type,
      _ref$name = _ref.name,
      name = _ref$name === void 0 ? "customFormIdentifier" : _ref$name,
      _ref$id = _ref.id,
      id = _ref$id === void 0 ? "customFormIdentifier" : _ref$id,
      className = _ref.className,
      dataHook = _ref.dataHook,
      value = _ref.value,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, CustomFormIdentifierField_excluded);

  var _useFormContext = (0,index_esm/* useFormContext */.Gc)(),
      register = _useFormContext.register;

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Input/* default */.Z, CustomFormIdentifierField_objectSpread(CustomFormIdentifierField_objectSpread({
    "data-testid": "custom-form-identifier-field",
    className: className,
    id: id,
    type: type,
    "data-hook": dataHook,
    value: value
  }, register(name, {})), rest));
};
// EXTERNAL MODULE: ../../libs/utils/regexes/form.ts
var regexes_form = __webpack_require__(63535);
;// CONCATENATED MODULE: ../../libs/templates/FormFields/SegmentWorkspace.tsx


var SegmentWorkspace_excluded = ["type", "name", "id", "placeholder", "label", "className", "dataHook"];

function SegmentWorkspace_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function SegmentWorkspace_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? SegmentWorkspace_ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : SegmentWorkspace_ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}






var segmentWorkspaceMessages = {
  required: "Please provide your Segment Worspace name.",
  invalid: "Please provide a valid Segment Worspace name."
};
/**
 * Segment workspace name input
 */

var SegmentWorkspaceField = function SegmentWorkspaceField(_ref) {
  var _errors$name;

  var _ref$type = _ref.type,
      type = _ref$type === void 0 ? "text" : _ref$type,
      _ref$name = _ref.name,
      name = _ref$name === void 0 ? "workspace" : _ref$name,
      _ref$id = _ref.id,
      id = _ref$id === void 0 ? "workspace" : _ref$id,
      _ref$placeholder = _ref.placeholder,
      placeholder = _ref$placeholder === void 0 ? "Segment Workspace name" : _ref$placeholder,
      label = _ref.label,
      className = _ref.className,
      dataHook = _ref.dataHook,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, SegmentWorkspace_excluded);

  var _useFormContext = (0,index_esm/* useFormContext */.Gc)(),
      register = _useFormContext.register,
      trigger = _useFormContext.trigger,
      errors = _useFormContext.formState.errors;

  var _useState = (0,react.useState)(false),
      valid = _useState[0],
      setValid = _useState[1];

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Input/* default */.Z, SegmentWorkspace_objectSpread(SegmentWorkspace_objectSpread({
    className: className,
    id: id,
    placeholder: placeholder,
    label: label,
    type: type,
    "aria-label": placeholder,
    error: Boolean(errors[name]),
    showValidState: valid && Boolean(!errors[name]),
    errorText: (_errors$name = errors[name]) === null || _errors$name === void 0 ? void 0 : _errors$name.message,
    expanded: true,
    "data-hook": dataHook,
    onAutoFill: function onAutoFill(value) {
      setValid(regexes_form/* default.test */.Z.test(value));
      trigger(name);
    }
  }, register(name, {
    required: segmentWorkspaceMessages.required,
    pattern: {
      value: regexes_form/* default */.Z,
      message: segmentWorkspaceMessages.invalid
    },
    onBlur: function onBlur(e) {
      setValid(regexes_form/* default.test */.Z.test(e.target.value));
    }
  })), rest));
};
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__(81333);
// EXTERNAL MODULE: ../../node_modules/react-use/esm/useDebounce.js
var useDebounce = __webpack_require__(63611);
// EXTERNAL MODULE: ../../libs/utils/useMatchMedia/index.ts + 1 modules
var useMatchMedia = __webpack_require__(61093);
// EXTERNAL MODULE: ../../node_modules/typesafe-actions/dist/typesafe-actions.umd.production.js
var typesafe_actions_umd_production = __webpack_require__(32145);
// EXTERNAL MODULE: ../../libs/api/staticSiteBackend/signup.ts
var signup = __webpack_require__(61157);
;// CONCATENATED MODULE: ../../libs/templates/FormFields/Password/data.ts
var passwordErrorMessages = {
  required: "Please choose a stronger password.",
  tooWeak: "Try adding symbols or uncommon words. Don't reuse a password from another site.",
  notSecure: "This password has been previously compromised in a data breach. This data breach was unrelated to Segment, but we make it our priority to ensure your account is secure.",
  tooShort: "Your password must be at least 8 characters."
};
;// CONCATENATED MODULE: ../../libs/templates/FormFields/Password/usePassword.tsx






var VALID = "VALID";
var ERROR = "ERROR";
var REQUIRED = "REQUIRED";
var TOO_WEAK = "TOO_WEAK";
var TOO_SHORT = "TOO_SHORT";
var NOT_SECURE = "NOT_SECURE";
var validAction = (0,typesafe_actions_umd_production.createAction)(VALID)();
var errorAction = (0,typesafe_actions_umd_production.createAction)(ERROR)();
var requiredAction = (0,typesafe_actions_umd_production.createAction)(REQUIRED)();
var tooWeakAction = (0,typesafe_actions_umd_production.createAction)(TOO_WEAK)();
var tooShortAction = (0,typesafe_actions_umd_production.createAction)(TOO_SHORT)();
var notSecureAction = (0,typesafe_actions_umd_production.createAction)(NOT_SECURE)();
var DEFAULT_OPTIONS = {
  errorMessage: undefined,
  valid: undefined,
  isPwned: false,
  isComplex: false,
  score: undefined
};

var reducer = function reducer(state, action) {
  switch (action.type) {
    case ERROR:
      {
        return {
          errorMessage: "Error trying to fetch email checking from API",
          valid: false,
          isPwned: false,
          isComplex: true,
          score: 0,
          error: true
        };
      }

    case VALID:
      {
        return {
          errorMessage: undefined,
          valid: true,
          isPwned: state.isPwned,
          isComplex: true,
          score: action.payload.score
        };
      }

    case REQUIRED:
      {
        return {
          errorMessage: passwordErrorMessages.required,
          valid: undefined,
          isPwned: false,
          isComplex: false,
          score: undefined
        };
      }

    case TOO_WEAK:
      {
        return {
          errorMessage: passwordErrorMessages.tooWeak,
          valid: false,
          isPwned: state.isPwned,
          isComplex: false,
          score: 0
        };
      }

    case NOT_SECURE:
      {
        return {
          errorMessage: passwordErrorMessages.notSecure,
          valid: false,
          isPwned: true,
          isComplex: action.payload.complex,
          score: action.payload.score
        };
      }

    case TOO_SHORT:
      {
        return {
          errorMessage: passwordErrorMessages.tooShort,
          valid: false,
          isPwned: action.payload.compromised,
          isComplex: action.payload.complex,
          score: action.payload.score
        };
      }

    default:
      {
        return DEFAULT_OPTIONS;
      }
  }
};

var usePassword = function usePassword() {
  var _useState = (0,react.useState)(undefined),
      value = _useState[0],
      setValue = _useState[1];

  var _useReducer = (0,react.useReducer)(reducer, DEFAULT_OPTIONS),
      state = _useReducer[0],
      dispatch = _useReducer[1];

  var valid = state.valid,
      isPwned = state.isPwned,
      isComplex = state.isComplex,
      score = state.score,
      errorMessage = state.errorMessage,
      error = state.error;

  var checkStrength = /*#__PURE__*/function () {
    var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(password) {
      var MIN_PASSWORD_LENGTH, MIN_VALID_SCORE, controller, pwdStrength, compromised, weak, _short, _score;

      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              MIN_PASSWORD_LENGTH = 8;
              MIN_VALID_SCORE = 1;
              setValue(password);

              if (!(password === "")) {
                _context.next = 6;
                break;
              }

              dispatch(requiredAction());
              return _context.abrupt("return");

            case 6:
              _context.prev = 6;
              controller = new AbortController();
              _context.next = 10;
              return (0,signup/* checkPassword */.oH)(controller.signal, password);

            case 10:
              pwdStrength = _context.sent;
              compromised = typeof pwdStrength.pwned === "number" && pwdStrength.pwned > 0;
              weak = typeof pwdStrength.score === "number" && pwdStrength.score <= MIN_VALID_SCORE;
              _short = password.length < MIN_PASSWORD_LENGTH;
              _score = pwdStrength.score;

              if (weak) {
                dispatch(tooWeakAction());
              } else if (_short) {
                dispatch(tooShortAction({
                  score: _score,
                  complex: !weak,
                  compromised: compromised
                }));
              } else if (compromised) {
                dispatch(notSecureAction({
                  score: _score,
                  complex: !weak
                }));
              } else {
                dispatch(validAction({
                  score: _score
                }));
              }

              _context.next = 21;
              break;

            case 18:
              _context.prev = 18;
              _context.t0 = _context["catch"](6);
              dispatch(errorAction({
                error: true
              }));

            case 21:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[6, 18]]);
    }));

    return function checkStrength(_x) {
      return _ref.apply(this, arguments);
    };
  }();

  return {
    valid: valid,
    isPwned: isPwned,
    isComplex: isComplex,
    score: score,
    errorMessage: errorMessage,
    password: value,
    apiError: error,
    checkStrength: checkStrength
  };
};


;// CONCATENATED MODULE: ../../libs/templates/FormFields/Password/Password.tsx





var Password_excluded = ["type", "name", "id", "placeholder", "label", "className", "dataHook", "helperLink", "helperText", "onValidate"];

function Password_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function Password_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? Password_ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Password_ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}



function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
/* eslint-disable react-hooks/exhaustive-deps */












/**
 * Password input
 */

var PasswordField = function PasswordField(_ref) {
  var _errors$name;

  var _ref$type = _ref.type,
      type = _ref$type === void 0 ? "password" : _ref$type,
      _ref$name = _ref.name,
      name = _ref$name === void 0 ? "password" : _ref$name,
      _ref$id = _ref.id,
      id = _ref$id === void 0 ? "password" : _ref$id,
      _ref$placeholder = _ref.placeholder,
      placeholder = _ref$placeholder === void 0 ? "Enter a strong password" : _ref$placeholder,
      label = _ref.label,
      className = _ref.className,
      dataHook = _ref.dataHook,
      _ref$helperLink = _ref.helperLink,
      helperLink = _ref$helperLink === void 0 ? "https://segment.com/docs/segment-app/iam/secure-password/#general-guidance" : _ref$helperLink,
      _ref$helperText = _ref.helperText,
      helperText = _ref$helperText === void 0 ? "Learn More." : _ref$helperText,
      onValidate = _ref.onValidate,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, Password_excluded);

  var theme = (0,emotion_element_6a883da9_browser_esm.u)();

  var _usePassword = usePassword(),
      valid = _usePassword.valid,
      isComplex = _usePassword.isComplex,
      score = _usePassword.score,
      isPwned = _usePassword.isPwned,
      errorMessage = _usePassword.errorMessage,
      apiError = _usePassword.apiError,
      checkStrength = _usePassword.checkStrength;

  var _useState = (0,react.useState)(""),
      value = _useState[0],
      setValue = _useState[1];

  var _useState2 = (0,react.useState)(false),
      isLoading = _useState2[0],
      setIsLoading = _useState2[1];

  var isMobileResolution = (0,useMatchMedia/* default */.Z)(theme.breakpoints.down("xs", false), true);
  var FULL_ERROR_MESSAGE_GAP = isMobileResolution ? 65 : 50;

  var _useFormContext = (0,index_esm/* useFormContext */.Gc)(),
      register = _useFormContext.register,
      errors = _useFormContext.formState.errors;

  (0,react.useEffect)(function () {
    if (onValidate) {
      onValidate(valid, isComplex, isPwned, errorMessage, apiError, isLoading);
    }
  }, [valid, isComplex, score, isPwned, errorMessage, apiError, isLoading]);

  var _useDebounce = (0,useDebounce/* default */.Z)( /*#__PURE__*/(0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
    return regenerator_default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            setIsLoading(true);
            _context.next = 3;
            return checkStrength(value);

          case 3:
            setIsLoading(false);

          case 4:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  })), 600, [value]),
      _useDebounce2 = (0,slicedToArray/* default */.Z)(_useDebounce, 2),
      cancel = _useDebounce2[1];

  (0,react.useEffect)(function () {
    return function () {
      cancel();
    };
  }, []);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Input/* default */.Z, Password_objectSpread(Password_objectSpread({
    className: className,
    id: id,
    placeholder: placeholder,
    label: label,
    type: type,
    "aria-label": placeholder,
    error: Boolean(errors[name]),
    showValidState: valid && Boolean(!errors[name]),
    errorText: (_errors$name = errors[name]) === null || _errors$name === void 0 ? void 0 : _errors$name.message,
    expanded: true,
    "data-hook": dataHook,
    isLoading: isLoading,
    autoComplete: "off"
  }, register(name, {
    validate: {
      required: function required(value) {
        return value ? undefined : passwordErrorMessages.required;
      },
      tooWeak: function tooWeak() {
        return isComplex ? undefined : passwordErrorMessages.tooWeak;
      },
      tooShort: function tooShort() {
        return valid ? undefined : passwordErrorMessages.tooShort;
      },
      notSecure: function notSecure() {
        return isPwned ? passwordErrorMessages.notSecure : undefined;
      }
    },
    onBlur: function onBlur(e) {
      setValue(e.target.value);
    },
    onChange: function onChange(e) {
      setValue(e.target.value);
    }
  })), {}, {
    after: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StrengthIndicator, {
      isComplex: isComplex,
      score: score,
      isValid: valid || false
    }),
    helperText: helperText,
    helperLink: helperLink,
    fullErrorMessageGap: FULL_ERROR_MESSAGE_GAP
  }, rest));
};

var StrengthIndicator = function StrengthIndicator(_ref3) {
  var score = _ref3.score,
      _ref3$isComplex = _ref3.isComplex,
      isComplex = _ref3$isComplex === void 0 ? false : _ref3$isComplex,
      _ref3$isValid = _ref3.isValid,
      isValid = _ref3$isValid === void 0 ? false : _ref3$isValid;
  var theme = (0,emotion_element_6a883da9_browser_esm.u)();
  var getColor = (0,react.useMemo)(function () {
    return function (position, theme) {
      var red = theme.palette.status.error[200];
      var yellow = theme.palette.status.warning[200];
      var green = theme.palette.status.success[200];
      var gray = theme.palette.twilio.gray[20];

      if (score === undefined) {
        return gray;
      }

      if (position < score || position === 0) {
        if (!isValid) {
          return red;
        }

        switch (score) {
          case 0:
            return red;

          case 1:
            return red;

          case 2:
            return isComplex ? yellow : red;

          case 3:
            return isComplex ? green : yellow;

          case 4:
            return green;

          default:
            return gray;
        }
      }

      return gray;
    };
  }, [score, isValid, isComplex]);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Password_Wrapper, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Pill, {
      "data-testid": "StrengthIndicator-pill-1",
      color: getColor(0, theme)
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Pill, {
      "data-testid": "StrengthIndicator-pill-2",
      color: getColor(1, theme)
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Pill, {
      "data-testid": "StrengthIndicator-pill-3",
      color: getColor(2, theme)
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Pill, {
      "data-testid": "StrengthIndicator-pill-4",
      color: getColor(3, theme)
    })]
  });
};

var Password_Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "ebo2pw91"
} : 0)( true ? {
  name: "oz0xnw",
  styles: "display:grid;gap:8px;grid-template-columns:1fr 1fr 1fr 1fr"
} : 0);

var Pill = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "ebo2pw90"
} : 0)("min-height:8px;background-color:", function (_ref4) {
  var color = _ref4.color;
  return color;
}, ";border-radius:10px;" + ( true ? "" : 0));

/* harmony default export */ var Password = (PasswordField);
;// CONCATENATED MODULE: ../../libs/templates/FormFields/Password/index.ts



// EXTERNAL MODULE: ../../libs/templates/FormFields/CompanyJobTitle.tsx
var CompanyJobTitle = __webpack_require__(10852);
// EXTERNAL MODULE: ../../libs/templates/FormFields/CompanySize.tsx
var CompanySize = __webpack_require__(20417);
// EXTERNAL MODULE: ../../libs/templates/FormFields/JobTitle.tsx
var JobTitle = __webpack_require__(96321);
// EXTERNAL MODULE: ../../libs/templates/FormFields/Timeline.tsx
var Timeline = __webpack_require__(12307);
// EXTERNAL MODULE: ../../libs/templates/FormFields/MonthlyTraffic.tsx
var MonthlyTraffic = __webpack_require__(75886);
;// CONCATENATED MODULE: ../../libs/templates/FormFields/Country.tsx


var Country_excluded = ["type", "name", "id", "placeholder", "className", "dataHook"];

function Country_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function Country_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? Country_ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Country_ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}






var countryMessages = {
  required: "Please provide your country of residence.",
  invalid: "Please provide a valid country."
};
var countryRegionMessages = {
  required: "Please provide your country or region of residence.",
  invalid: "Please provide a valid country or region."
};
var CountryField = function CountryField(_ref) {
  var _errors$name;

  var _ref$type = _ref.type,
      type = _ref$type === void 0 ? "text" : _ref$type,
      _ref$name = _ref.name,
      name = _ref$name === void 0 ? "country" : _ref$name,
      _ref$id = _ref.id,
      id = _ref$id === void 0 ? "country" : _ref$id,
      _ref$placeholder = _ref.placeholder,
      placeholder = _ref$placeholder === void 0 ? "Country of residence" : _ref$placeholder,
      className = _ref.className,
      dataHook = _ref.dataHook,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, Country_excluded);

  var _useFormContext = (0,index_esm/* useFormContext */.Gc)(),
      register = _useFormContext.register,
      trigger = _useFormContext.trigger,
      errors = _useFormContext.formState.errors;

  var _useState = (0,react.useState)(false),
      valid = _useState[0],
      setValid = _useState[1];

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Input/* default */.Z, Country_objectSpread(Country_objectSpread({
    className: className,
    id: id,
    placeholder: placeholder,
    type: type,
    "aria-label": placeholder,
    error: Boolean(errors[name]),
    showValidState: valid && Boolean(!errors[name]),
    errorText: (_errors$name = errors[name]) === null || _errors$name === void 0 ? void 0 : _errors$name.message,
    expanded: true,
    "data-hook": dataHook,
    onAutoFill: function onAutoFill(value) {
      setValid(regexes_form/* default.test */.Z.test(value));
      trigger(name);
    }
  }, register(name)), rest));
};
/* harmony default export */ var Country = (CountryField);
// EXTERNAL MODULE: ../../libs/utils/regexes/name.ts
var regexes_name = __webpack_require__(11703);
;// CONCATENATED MODULE: ../../libs/templates/FormFields/FirstName.tsx


var FirstName_excluded = ["type", "name", "id", "placeholder", "className", "dataHook"];

function FirstName_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function FirstName_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? FirstName_ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : FirstName_ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}






var firstNameMessages = {
  required: "Please provide your first name.",
  invalid: "Please provide a valid first name."
};
/**
 * First Name input
 */

var FirstNameField = function FirstNameField(_ref) {
  var _errors$name;

  var _ref$type = _ref.type,
      type = _ref$type === void 0 ? "text" : _ref$type,
      _ref$name = _ref.name,
      name = _ref$name === void 0 ? "firstName" : _ref$name,
      _ref$id = _ref.id,
      id = _ref$id === void 0 ? "firstName" : _ref$id,
      _ref$placeholder = _ref.placeholder,
      placeholder = _ref$placeholder === void 0 ? "First name" : _ref$placeholder,
      className = _ref.className,
      dataHook = _ref.dataHook,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, FirstName_excluded);

  var _useFormContext = (0,index_esm/* useFormContext */.Gc)(),
      register = _useFormContext.register,
      trigger = _useFormContext.trigger,
      errors = _useFormContext.formState.errors;

  var _useState = (0,react.useState)(false),
      valid = _useState[0],
      setValid = _useState[1];

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Input/* default */.Z, FirstName_objectSpread(FirstName_objectSpread({
    className: className,
    id: id,
    placeholder: placeholder,
    type: type,
    "aria-label": placeholder,
    error: Boolean(errors[name]),
    showValidState: valid && Boolean(!errors[name]),
    errorText: (_errors$name = errors[name]) === null || _errors$name === void 0 ? void 0 : _errors$name.message,
    expanded: true,
    "data-hook": dataHook,
    onAutoFill: function onAutoFill(value) {
      setValid(regexes_name/* default.test */.Z.test(value));
      trigger(name);
    }
  }, register(name, {
    required: firstNameMessages.required,
    validate: function validate(value) {
      return regexes_name/* default.test */.Z.test(value) || firstNameMessages.invalid;
    },
    onBlur: function onBlur(e) {
      setValid(regexes_name/* default.test */.Z.test(e.target.value));
    }
  })), rest));
};
;// CONCATENATED MODULE: ../../libs/templates/FormFields/LastName.tsx


var LastName_excluded = ["type", "name", "id", "placeholder", "className", "dataHook"];

function LastName_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function LastName_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? LastName_ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : LastName_ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}






var lastNameMessages = {
  required: "Please provide your last name.",
  invalid: "Please provide a valid last name."
};
/**
 * Last Name input
 */

var LastNameField = function LastNameField(_ref) {
  var _errors$name;

  var _ref$type = _ref.type,
      type = _ref$type === void 0 ? "text" : _ref$type,
      _ref$name = _ref.name,
      name = _ref$name === void 0 ? "lastName" : _ref$name,
      _ref$id = _ref.id,
      id = _ref$id === void 0 ? "lastName" : _ref$id,
      _ref$placeholder = _ref.placeholder,
      placeholder = _ref$placeholder === void 0 ? "Last name" : _ref$placeholder,
      className = _ref.className,
      dataHook = _ref.dataHook,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, LastName_excluded);

  var _useFormContext = (0,index_esm/* useFormContext */.Gc)(),
      register = _useFormContext.register,
      trigger = _useFormContext.trigger,
      errors = _useFormContext.formState.errors;

  var _useState = (0,react.useState)(false),
      valid = _useState[0],
      setValid = _useState[1];

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Input/* default */.Z, LastName_objectSpread(LastName_objectSpread({
    className: className,
    id: id,
    placeholder: placeholder,
    type: type,
    "aria-label": placeholder,
    error: Boolean(errors[name]),
    showValidState: valid && Boolean(!errors[name]),
    errorText: (_errors$name = errors[name]) === null || _errors$name === void 0 ? void 0 : _errors$name.message,
    expanded: true,
    "data-hook": dataHook,
    onAutoFill: function onAutoFill(value) {
      setValid(regexes_name/* default.test */.Z.test(value));
      trigger(name);
    }
  }, register(name, {
    required: lastNameMessages.required,
    validate: function validate(value) {
      return regexes_name/* default.test */.Z.test(value) || lastNameMessages.invalid;
    },
    onBlur: function onBlur(e) {
      setValid(regexes_name/* default.test */.Z.test(e.target.value));
    }
  })), rest));
};
;// CONCATENATED MODULE: ../../libs/templates/FormFields/City.tsx


var City_excluded = ["type", "name", "id", "placeholder", "className", "dataHook"];

function City_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function City_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? City_ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : City_ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}




var cityMessages = {
  required: "Please provide your city name.",
  invalid: "Please provide a valid city."
};
var CityField = function CityField(_ref) {
  var _errors$name;

  var _ref$type = _ref.type,
      type = _ref$type === void 0 ? "text" : _ref$type,
      _ref$name = _ref.name,
      name = _ref$name === void 0 ? "city" : _ref$name,
      _ref$id = _ref.id,
      id = _ref$id === void 0 ? "city" : _ref$id,
      _ref$placeholder = _ref.placeholder,
      placeholder = _ref$placeholder === void 0 ? "City" : _ref$placeholder,
      className = _ref.className,
      dataHook = _ref.dataHook,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, City_excluded);

  var _useFormContext = (0,index_esm/* useFormContext */.Gc)(),
      register = _useFormContext.register,
      trigger = _useFormContext.trigger,
      _useFormContext$formS = _useFormContext.formState,
      errors = _useFormContext$formS.errors,
      touchedFields = _useFormContext$formS.touchedFields;

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Input/* default */.Z, City_objectSpread(City_objectSpread({
    className: className,
    id: id,
    placeholder: placeholder,
    type: type,
    "aria-label": placeholder,
    error: Boolean(errors[name]),
    showValidState: touchedFields[name] && Boolean(!errors[name]),
    errorText: (_errors$name = errors[name]) === null || _errors$name === void 0 ? void 0 : _errors$name.message,
    expanded: true,
    "data-hook": dataHook,
    onAutoFill: function onAutoFill() {
      trigger(name);
    }
  }, register(name)), rest));
};
/* harmony default export */ var City = (CityField);
;// CONCATENATED MODULE: ../../libs/templates/FormFields/State.tsx


var State_excluded = ["type", "name", "id", "placeholder", "className", "dataHook"];

function State_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function State_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? State_ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : State_ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}




var stateMessages = {
  required: "Please provide your state name.",
  invalid: "Please provide a valid state."
};
var StateField = function StateField(_ref) {
  var _errors$name;

  var _ref$type = _ref.type,
      type = _ref$type === void 0 ? "text" : _ref$type,
      _ref$name = _ref.name,
      name = _ref$name === void 0 ? "state" : _ref$name,
      _ref$id = _ref.id,
      id = _ref$id === void 0 ? "state" : _ref$id,
      _ref$placeholder = _ref.placeholder,
      placeholder = _ref$placeholder === void 0 ? "State" : _ref$placeholder,
      className = _ref.className,
      dataHook = _ref.dataHook,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, State_excluded);

  var _useFormContext = (0,index_esm/* useFormContext */.Gc)(),
      register = _useFormContext.register,
      trigger = _useFormContext.trigger,
      _useFormContext$formS = _useFormContext.formState,
      errors = _useFormContext$formS.errors,
      touchedFields = _useFormContext$formS.touchedFields;

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Input/* default */.Z, State_objectSpread(State_objectSpread({
    className: className,
    id: id,
    placeholder: placeholder,
    type: type,
    "aria-label": placeholder,
    error: Boolean(errors[name]),
    showValidState: touchedFields[name] && Boolean(!errors[name]),
    errorText: (_errors$name = errors[name]) === null || _errors$name === void 0 ? void 0 : _errors$name.message,
    expanded: true,
    "data-hook": dataHook,
    onAutoFill: function onAutoFill() {
      trigger(name);
    }
  }, register(name)), rest));
};
/* harmony default export */ var State = (StateField);
;// CONCATENATED MODULE: ../../libs/templates/FormFields/AddressLine.tsx


var AddressLine_excluded = ["type", "name", "id", "placeholder", "autoComplete", "label", "className", "dataHook"];

function AddressLine_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function AddressLine_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? AddressLine_ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : AddressLine_ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}




var addressLineMessages = {
  required: "Please provide your mailing  address.",
  invalid: function invalid() {
    var characterLimit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 90;
    return "Please provide a valid address line: max ".concat(characterLimit, " characters, no special characters.");
  }
};
var AddressLineField = function AddressLineField(_ref) {
  var _errors$name;

  var _ref$type = _ref.type,
      type = _ref$type === void 0 ? "text" : _ref$type,
      _ref$name = _ref.name,
      name = _ref$name === void 0 ? "addressLine" : _ref$name,
      _ref$id = _ref.id,
      id = _ref$id === void 0 ? "addressLine" : _ref$id,
      _ref$placeholder = _ref.placeholder,
      placeholder = _ref$placeholder === void 0 ? "Address line" : _ref$placeholder,
      _ref$autoComplete = _ref.autoComplete,
      autoComplete = _ref$autoComplete === void 0 ? "address-line1" : _ref$autoComplete,
      label = _ref.label,
      className = _ref.className,
      dataHook = _ref.dataHook,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, AddressLine_excluded);

  var _useFormContext = (0,index_esm/* useFormContext */.Gc)(),
      register = _useFormContext.register,
      trigger = _useFormContext.trigger,
      _useFormContext$formS = _useFormContext.formState,
      errors = _useFormContext$formS.errors,
      touchedFields = _useFormContext$formS.touchedFields;

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Input/* default */.Z, AddressLine_objectSpread(AddressLine_objectSpread({
    className: className,
    id: id,
    placeholder: placeholder,
    label: label,
    type: type,
    "aria-label": placeholder,
    error: Boolean(errors[name]),
    showValidState: touchedFields[name] && Boolean(!errors[name]),
    errorText: (_errors$name = errors[name]) === null || _errors$name === void 0 ? void 0 : _errors$name.message,
    expanded: true,
    "data-hook": dataHook,
    autoComplete: autoComplete,
    onAutoFill: function onAutoFill() {
      trigger(name);
    }
  }, register(name)), rest));
};
/* harmony default export */ var AddressLine = (AddressLineField);
;// CONCATENATED MODULE: ../../libs/templates/FormFields/PostalCode.tsx


var PostalCode_excluded = ["type", "name", "id", "placeholder", "autoComplete", "label", "className", "dataHook"];

function PostalCode_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function PostalCode_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? PostalCode_ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : PostalCode_ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}




var postalCodeMessages = {
  required: "Please provide your ZIP code / Postcode / Postal code.",
  invalid: "Please provide a valid ZIP code / Postal code."
};
var PostalCodeField = function PostalCodeField(_ref) {
  var _errors$name;

  var _ref$type = _ref.type,
      type = _ref$type === void 0 ? "text" : _ref$type,
      _ref$name = _ref.name,
      name = _ref$name === void 0 ? "postalCode" : _ref$name,
      _ref$id = _ref.id,
      id = _ref$id === void 0 ? "postalCode" : _ref$id,
      _ref$placeholder = _ref.placeholder,
      placeholder = _ref$placeholder === void 0 ? "Your ZIP code / Postcode / Postal code" : _ref$placeholder,
      _ref$autoComplete = _ref.autoComplete,
      autoComplete = _ref$autoComplete === void 0 ? "postal-code" : _ref$autoComplete,
      label = _ref.label,
      className = _ref.className,
      dataHook = _ref.dataHook,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, PostalCode_excluded);

  var _useFormContext = (0,index_esm/* useFormContext */.Gc)(),
      register = _useFormContext.register,
      trigger = _useFormContext.trigger,
      _useFormContext$formS = _useFormContext.formState,
      errors = _useFormContext$formS.errors,
      touchedFields = _useFormContext$formS.touchedFields;

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Input/* default */.Z, PostalCode_objectSpread(PostalCode_objectSpread({
    className: className,
    id: id,
    placeholder: placeholder,
    label: label,
    type: type,
    "aria-label": placeholder,
    error: Boolean(errors[name]),
    showValidState: touchedFields[name] && Boolean(!errors[name]),
    errorText: (_errors$name = errors[name]) === null || _errors$name === void 0 ? void 0 : _errors$name.message,
    expanded: true,
    "data-hook": dataHook,
    autoComplete: autoComplete,
    onAutoFill: function onAutoFill() {
      trigger(name);
    }
  }, register(name)), rest));
};
/* harmony default export */ var PostalCode = (PostalCodeField);
// EXTERNAL MODULE: ../../libs/matcha/foundations/AppearanceContext/index.ts + 1 modules
var AppearanceContext = __webpack_require__(9381);
// EXTERNAL MODULE: ../../libs/matcha/components/Icons/Common.ts + 14 modules
var Common = __webpack_require__(6580);
// EXTERNAL MODULE: ../../libs/matcha/components/Select/useSelect/index.ts + 3 modules
var useSelect = __webpack_require__(27431);
// EXTERNAL MODULE: ../../libs/matcha/components/Select/index.ts + 9 modules
var Select = __webpack_require__(44502);
;// CONCATENATED MODULE: ../../libs/templates/FormFields/CurrentTwilioCustomer.tsx



var CurrentTwilioCustomer_excluded = ["name", "id", "placeholder", "label", "dataHook"];

function CurrentTwilioCustomer_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function CurrentTwilioCustomer_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? CurrentTwilioCustomer_ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : CurrentTwilioCustomer_ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function CurrentTwilioCustomer_EMOTION_STRINGIFIED_CSS_ERROR_() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}











var currentTwilioCustomerMessages = {
  required: "Please select a valid option.",
  invalid: "Please select a valid option."
};
var options = [{
  value: "yes",
  text: "Yes"
}, {
  value: "no",
  text: "No"
}];
var CurrentTwilioCustomerSelectField = function CurrentTwilioCustomerSelectField(_ref) {
  var _errors$name;

  var _ref$name = _ref.name,
      name = _ref$name === void 0 ? "currentTwilioCustomer" : _ref$name,
      _ref$id = _ref.id,
      id = _ref$id === void 0 ? "currentTwilioCustomer" : _ref$id,
      _ref$placeholder = _ref.placeholder,
      placeholder = _ref$placeholder === void 0 ? "Select one" : _ref$placeholder,
      _ref$label = _ref.label,
      label = _ref$label === void 0 ? "Current Twilio Customer *" : _ref$label,
      _ref$dataHook = _ref.dataHook,
      dataHook = _ref$dataHook === void 0 ? "currentTwilioCustomer" : _ref$dataHook,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, CurrentTwilioCustomer_excluded);

  var theme = (0,emotion_element_6a883da9_browser_esm.u)();
  var appearance = (0,AppearanceContext/* useAppearance */.M)();
  var iconColor = appearance === "dark" ? theme.palette.neutrals.white[100] : theme.palette.twilio.gray[80];

  var _useFormContext = (0,index_esm/* useFormContext */.Gc)(),
      register = _useFormContext.register,
      setValue = _useFormContext.setValue,
      errors = _useFormContext.formState.errors,
      clearErrors = _useFormContext.clearErrors;

  var _useSelect = (0,useSelect/* default */.Z)({
    options: options,
    id: id,
    onSelect: function onSelect() {
      setValue(name, state.selected[0].text);
      setValid(true);
      clearErrors(name);
    },
    appearance: "twilioLight"
  }),
      state = _useSelect.state,
      getControlProps = _useSelect.getControlProps,
      filteredOptions = _useSelect.filteredOptions,
      getSelectProps = _useSelect.getSelectProps;

  var _useState = (0,react.useState)(false),
      valid = _useState[0],
      setValid = _useState[1];

  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CurrentTwilioCustomer_Wrapper, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Input/* default */.Z, CurrentTwilioCustomer_objectSpread(CurrentTwilioCustomer_objectSpread(CurrentTwilioCustomer_objectSpread({
      id: id,
      type: "search",
      label: label,
      error: Boolean(errors[name]),
      showValidState: valid && Boolean(!errors[name]),
      errorText: (_errors$name = errors[name]) === null || _errors$name === void 0 ? void 0 : _errors$name.message,
      resetable: state.filterValue !== "",
      rightSecondIcon: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Common/* ChevronDownIcon */.v4, {
        color: iconColor
      }),
      "data-testid": dataHook
    }, register(name, {
      required: currentTwilioCustomerMessages.required,
      onBlur: function onBlur(e) {
        setValid(Boolean(e.target.value));
      }
    })), getControlProps({
      placeholder: placeholder
    })), rest)), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SelectWrapper, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Select/* default */.ZP, CurrentTwilioCustomer_objectSpread({
        id: "".concat(id, "Select"),
        name: name,
        options: options,
        filteredOptions: filteredOptions,
        displayMode: state.displayMode,
        open: state.open
      }, getSelectProps()))
    })]
  });
};

var CurrentTwilioCustomer_Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e16cntbw1"
} : 0)( true ? {
  name: "bjn8wh",
  styles: "position:relative"
} : 0);

var SelectWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e16cntbw0"
} : 0)( true ? {
  name: "10k07g3",
  styles: "position:relative;z-index:3"
} : 0);

/* harmony default export */ var CurrentTwilioCustomer = (CurrentTwilioCustomerSelectField);
// EXTERNAL MODULE: ../../libs/matcha/components/TextArea/index.ts + 2 modules
var TextArea = __webpack_require__(94721);
;// CONCATENATED MODULE: ../../libs/templates/FormFields/DetailsOfInterest.tsx


var DetailsOfInterest_excluded = ["name", "id", "placeholder", "label", "className", "dataHook"];

function DetailsOfInterest_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function DetailsOfInterest_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? DetailsOfInterest_ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : DetailsOfInterest_ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}






var detailsOfInterestMessages = {
  required: "Please provide details of interest with Segment.",
  invalid: "Please provide details of interest with Segment."
};
var DetailsOfInterestField = function DetailsOfInterestField(_ref) {
  var _errors$name;

  var _ref$name = _ref.name,
      name = _ref$name === void 0 ? "detailsOfInterest" : _ref$name,
      _ref$id = _ref.id,
      id = _ref$id === void 0 ? "detailsOfInterest" : _ref$id,
      _ref$placeholder = _ref.placeholder,
      placeholder = _ref$placeholder === void 0 ? "" : _ref$placeholder,
      _ref$label = _ref.label,
      label = _ref$label === void 0 ? "Details of interest with Segment *" : _ref$label,
      className = _ref.className,
      dataHook = _ref.dataHook,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, DetailsOfInterest_excluded);

  var _useFormContext = (0,index_esm/* useFormContext */.Gc)(),
      register = _useFormContext.register,
      errors = _useFormContext.formState.errors;

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TextArea/* default */.Z, DetailsOfInterest_objectSpread(DetailsOfInterest_objectSpread({
      id: id,
      expanded: true,
      label: label,
      placeholder: placeholder,
      error: Boolean(errors[name]),
      errorText: (_errors$name = errors[name]) === null || _errors$name === void 0 ? void 0 : _errors$name.message,
      maxWidth: "720px",
      rows: 3,
      "data-hook": dataHook
    }, register(name, {
      required: detailsOfInterestMessages.required,
      validate: function validate(value) {
        return regexes_name/* default.test */.Z.test(value) || detailsOfInterestMessages.invalid;
      }
    })), {}, {
      className: className
    }, rest))
  });
};
/* harmony default export */ var DetailsOfInterest = (DetailsOfInterestField);
;// CONCATENATED MODULE: ../../libs/templates/FormFields/DetailsOfRelationship.tsx


var DetailsOfRelationship_excluded = ["name", "id", "placeholder", "label", "className", "dataHook"];

function DetailsOfRelationship_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function DetailsOfRelationship_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? DetailsOfRelationship_ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : DetailsOfRelationship_ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}






var detailsOfRelationshipMessages = {
  required: "Please provide details of relationship.",
  invalid: "Please provide details of relationship."
};
var DetailsOfRelationshipField = function DetailsOfRelationshipField(_ref) {
  var _errors$name;

  var _ref$name = _ref.name,
      name = _ref$name === void 0 ? "detailsOfRelationship" : _ref$name,
      _ref$id = _ref.id,
      id = _ref$id === void 0 ? "detailsOfRelationship" : _ref$id,
      _ref$placeholder = _ref.placeholder,
      placeholder = _ref$placeholder === void 0 ? "" : _ref$placeholder,
      _ref$label = _ref.label,
      label = _ref$label === void 0 ? "Details of relationship *" : _ref$label,
      className = _ref.className,
      dataHook = _ref.dataHook,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, DetailsOfRelationship_excluded);

  var _useFormContext = (0,index_esm/* useFormContext */.Gc)(),
      register = _useFormContext.register,
      errors = _useFormContext.formState.errors;

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TextArea/* default */.Z, DetailsOfRelationship_objectSpread(DetailsOfRelationship_objectSpread({
      id: id,
      expanded: true,
      label: label,
      placeholder: placeholder,
      error: Boolean(errors[name]),
      errorText: (_errors$name = errors[name]) === null || _errors$name === void 0 ? void 0 : _errors$name.message,
      maxWidth: "720px",
      rows: 3,
      "data-hook": dataHook
    }, register(name, {
      required: detailsOfRelationshipMessages.required,
      validate: function validate(value) {
        return regexes_name/* default.test */.Z.test(value) || detailsOfRelationshipMessages.invalid;
      }
    })), {}, {
      className: className
    }, rest))
  });
};
/* harmony default export */ var DetailsOfRelationship = (DetailsOfRelationshipField);
;// CONCATENATED MODULE: ../../libs/templates/FormFields/MarketingCampaignsLead.tsx



var MarketingCampaignsLead_excluded = ["name", "id", "placeholder", "label", "dataHook"];

function MarketingCampaignsLead_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function MarketingCampaignsLead_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? MarketingCampaignsLead_ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : MarketingCampaignsLead_ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function MarketingCampaignsLead_EMOTION_STRINGIFIED_CSS_ERROR_() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}











var marketingCampaignsLeadMessages = {
  required: "Please select a valid option.",
  invalid: "Please select a valid option."
};
var MarketingCampaignsLead_options = [{
  value: "yes",
  text: "Yes"
}, {
  value: "no",
  text: "No"
}];
var MarketingCampaignsLeadSelectField = function MarketingCampaignsLeadSelectField(_ref) {
  var _errors$name;

  var _ref$name = _ref.name,
      name = _ref$name === void 0 ? "marketingCampaignsLead" : _ref$name,
      _ref$id = _ref.id,
      id = _ref$id === void 0 ? "marketingCampaignsLead" : _ref$id,
      _ref$placeholder = _ref.placeholder,
      placeholder = _ref$placeholder === void 0 ? "Select one" : _ref$placeholder,
      _ref$label = _ref.label,
      label = _ref$label === void 0 ? "Is this a Marketing Campaigns (MC) Lead? *" : _ref$label,
      _ref$dataHook = _ref.dataHook,
      dataHook = _ref$dataHook === void 0 ? "marketingCampaignsLead" : _ref$dataHook,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, MarketingCampaignsLead_excluded);

  var theme = (0,emotion_element_6a883da9_browser_esm.u)();
  var appearance = (0,AppearanceContext/* useAppearance */.M)();
  var iconColor = appearance === "dark" ? theme.palette.neutrals.white[100] : theme.palette.twilio.gray[80];

  var _useFormContext = (0,index_esm/* useFormContext */.Gc)(),
      register = _useFormContext.register,
      setValue = _useFormContext.setValue,
      errors = _useFormContext.formState.errors,
      clearErrors = _useFormContext.clearErrors;

  var _useSelect = (0,useSelect/* default */.Z)({
    options: MarketingCampaignsLead_options,
    id: id,
    onSelect: function onSelect() {
      setValue(name, state.selected[0].text);
      setValid(true);
      clearErrors(name);
    },
    appearance: "twilioLight"
  }),
      state = _useSelect.state,
      getControlProps = _useSelect.getControlProps,
      filteredOptions = _useSelect.filteredOptions,
      getSelectProps = _useSelect.getSelectProps;

  var _useState = (0,react.useState)(false),
      valid = _useState[0],
      setValid = _useState[1];

  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(MarketingCampaignsLead_Wrapper, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Input/* default */.Z, MarketingCampaignsLead_objectSpread(MarketingCampaignsLead_objectSpread(MarketingCampaignsLead_objectSpread({
      id: id,
      type: "search",
      label: label,
      error: Boolean(errors[name]),
      showValidState: valid && Boolean(!errors[name]),
      errorText: (_errors$name = errors[name]) === null || _errors$name === void 0 ? void 0 : _errors$name.message,
      resetable: state.filterValue !== "",
      rightSecondIcon: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Common/* ChevronDownIcon */.v4, {
        color: iconColor
      }),
      "data-testid": dataHook
    }, register(name, {
      required: marketingCampaignsLeadMessages.required,
      onBlur: function onBlur(e) {
        setValid(Boolean(e.target.value));
      }
    })), getControlProps({
      placeholder: placeholder
    })), rest)), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MarketingCampaignsLead_SelectWrapper, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Select/* default */.ZP, MarketingCampaignsLead_objectSpread({
        id: "".concat(id, "Select"),
        name: name,
        options: MarketingCampaignsLead_options,
        filteredOptions: filteredOptions,
        displayMode: state.displayMode,
        open: state.open
      }, getSelectProps()))
    })]
  });
};

var MarketingCampaignsLead_Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e113926n1"
} : 0)( true ? {
  name: "bjn8wh",
  styles: "position:relative"
} : 0);

var MarketingCampaignsLead_SelectWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e113926n0"
} : 0)( true ? {
  name: "10k07g3",
  styles: "position:relative;z-index:3"
} : 0);

/* harmony default export */ var MarketingCampaignsLead = (MarketingCampaignsLeadSelectField);
;// CONCATENATED MODULE: ../../libs/templates/FormFields/TwilioSpendLevel.tsx



var TwilioSpendLevel_excluded = ["name", "id", "placeholder", "label", "dataHook"];

function TwilioSpendLevel_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function TwilioSpendLevel_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? TwilioSpendLevel_ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : TwilioSpendLevel_ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function TwilioSpendLevel_EMOTION_STRINGIFIED_CSS_ERROR_() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}











var twilioSpendLevelMessages = {
  required: "Please select a valid option.",
  invalid: "Please select a valid option."
};
var TwilioSpendLevel_options = [{
  value: "under50k",
  text: "<$50k"
}, {
  value: "between50kand100k",
  text: "$50k - $100k"
}, {
  value: "between100kand200k",
  text: "$100k - $200k"
}, {
  value: "between200kand500k",
  text: "$200k - $500k"
}, {
  value: "over500k",
  text: "$500k+"
}, {
  value: "notApplicable",
  text: "N/A"
}];
var TwilioSpendLevelSelectField = function TwilioSpendLevelSelectField(_ref) {
  var _errors$name;

  var _ref$name = _ref.name,
      name = _ref$name === void 0 ? "twilioSpendLevel" : _ref$name,
      _ref$id = _ref.id,
      id = _ref$id === void 0 ? "twilioSpendLevel" : _ref$id,
      _ref$placeholder = _ref.placeholder,
      placeholder = _ref$placeholder === void 0 ? "Select one" : _ref$placeholder,
      _ref$label = _ref.label,
      label = _ref$label === void 0 ? "Twilio Spend Level *" : _ref$label,
      _ref$dataHook = _ref.dataHook,
      dataHook = _ref$dataHook === void 0 ? "twilioSpendLevel" : _ref$dataHook,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, TwilioSpendLevel_excluded);

  var theme = (0,emotion_element_6a883da9_browser_esm.u)();
  var appearance = (0,AppearanceContext/* useAppearance */.M)();
  var iconColor = appearance === "dark" ? theme.palette.neutrals.white[100] : theme.palette.twilio.gray[80];

  var _useFormContext = (0,index_esm/* useFormContext */.Gc)(),
      register = _useFormContext.register,
      setValue = _useFormContext.setValue,
      errors = _useFormContext.formState.errors,
      clearErrors = _useFormContext.clearErrors;

  var _useSelect = (0,useSelect/* default */.Z)({
    options: TwilioSpendLevel_options,
    id: id,
    onSelect: function onSelect() {
      setValue(name, state.selected[0].text);
      setValid(true);
      clearErrors(name);
    },
    appearance: "twilioLight"
  }),
      state = _useSelect.state,
      getControlProps = _useSelect.getControlProps,
      filteredOptions = _useSelect.filteredOptions,
      getSelectProps = _useSelect.getSelectProps;

  var _useState = (0,react.useState)(false),
      valid = _useState[0],
      setValid = _useState[1];

  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(TwilioSpendLevel_Wrapper, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Input/* default */.Z, TwilioSpendLevel_objectSpread(TwilioSpendLevel_objectSpread(TwilioSpendLevel_objectSpread({
      id: id,
      type: "search",
      label: label,
      error: Boolean(errors[name]),
      showValidState: valid && Boolean(!errors[name]),
      errorText: (_errors$name = errors[name]) === null || _errors$name === void 0 ? void 0 : _errors$name.message,
      resetable: state.filterValue !== "",
      rightSecondIcon: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Common/* ChevronDownIcon */.v4, {
        color: iconColor
      }),
      "data-testid": dataHook
    }, register(name, {
      required: twilioSpendLevelMessages.required,
      onBlur: function onBlur(e) {
        setValid(Boolean(e.target.value));
      }
    })), getControlProps({
      placeholder: placeholder
    })), rest)), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TwilioSpendLevel_SelectWrapper, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Select/* default */.ZP, TwilioSpendLevel_objectSpread({
        id: "".concat(id, "Select"),
        name: name,
        options: TwilioSpendLevel_options,
        filteredOptions: filteredOptions,
        displayMode: state.displayMode,
        open: state.open
      }, getSelectProps()))
    })]
  });
};

var TwilioSpendLevel_Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1mluwbe1"
} : 0)( true ? {
  name: "bjn8wh",
  styles: "position:relative"
} : 0);

var TwilioSpendLevel_SelectWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1mluwbe0"
} : 0)( true ? {
  name: "10k07g3",
  styles: "position:relative;z-index:3"
} : 0);

/* harmony default export */ var TwilioSpendLevel = (TwilioSpendLevelSelectField);
;// CONCATENATED MODULE: ../../libs/templates/FormFields/index.ts

























/***/ }),

/***/ 39466:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "MJ": function() { return /* binding */ StyledDescription; },
/* harmony export */   "Sn": function() { return /* binding */ StyledButton; },
/* harmony export */   "fN": function() { return /* binding */ StyledTypography; },
/* harmony export */   "h4": function() { return /* binding */ Header; },
/* harmony export */   "im": function() { return /* binding */ Wrapper; }
/* harmony export */ });
/* harmony import */ var _emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92952);
/* harmony import */ var _segment_matcha_components_Typography__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(89533);
/* harmony import */ var _segment_matcha_components_Button__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(33445);


function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}



var Wrapper = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("div",  true ? {
  target: "e16gsc9g4"
} : 0)("padding:", function (_ref) {
  var compact = _ref.compact;
  return compact ? 0 : 32;
}, "px;border:", function (_ref2) {
  var borderless = _ref2.borderless,
      borderColor = _ref2.borderColor;
  return borderless ? "none" : "1px solid ".concat(borderColor);
}, ";border-radius:8px;text-align:left;" + ( true ? "" : 0));
var Header = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("div",  true ? {
  target: "e16gsc9g3"
} : 0)( true ? {
  name: "9qwgfz",
  styles: "display:grid;grid-auto-flow:column;grid-template-columns:max-content 1fr;align-items:center;gap:8px"
} : 0);
var StyledTypography = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_segment_matcha_components_Typography__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z,  true ? {
  target: "e16gsc9g2"
} : 0)( true ? {
  name: "ti75j2",
  styles: "margin:0"
} : 0);
var StyledDescription = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_segment_matcha_components_Typography__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z,  true ? {
  target: "e16gsc9g1"
} : 0)( true ? {
  name: "16qkf0x",
  styles: "margin-top:16px;margin-bottom:0"
} : 0);
var StyledButton = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_segment_matcha_components_Button__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z,  true ? {
  target: "e16gsc9g0"
} : 0)( true ? {
  name: "157sdy5",
  styles: "margin-top:26px"
} : 0);

/***/ }),

/***/ 17433:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ FormSubmitAction; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(82269);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/dist/emotion-element-6a883da9.browser.esm.js + 1 modules
var emotion_element_6a883da9_browser_esm = __webpack_require__(28543);
// EXTERNAL MODULE: ../../libs/matcha/foundations/AppearanceContext/index.ts + 1 modules
var AppearanceContext = __webpack_require__(9381);
// EXTERNAL MODULE: ../../libs/matcha/components/Icons/Common.ts + 14 modules
var Common = __webpack_require__(6580);
// EXTERNAL MODULE: ../../libs/matcha/useDesignTokens/index.ts
var useDesignTokens = __webpack_require__(98439);
;// CONCATENATED MODULE: ../../libs/templates/FormSubmitAction/data.tsx
var data = {
  success: {
    demo: {
      heading: "Thank you",
      description: "We'll get back to you with a demo shortly. For now, you can create your workspace by clicking below:",
      buttonText: "Create your free workspace"
    },
    emailCapture: {
      heading: "Thank you",
      description: "Check your inbox for an email confirmation with a link to the report. You can also click the link below to access now:"
    }
  },
  error: {
    demo: {
      heading: "Something happened",
      description: "We are really sorry. There was an error processing your submission. Try reloading your browser, and submitting again.",
      buttonText: ""
    },
    emailCapture: {
      heading: "Something happened",
      description: "We are really sorry. There was an error processing your submission. Try reloading your browser, and submitting again.",
      buttonText: ""
    }
  }
};
// EXTERNAL MODULE: ../../libs/templates/FormSubmitAction/FormSubmitAction.views.tsx
var FormSubmitAction_views = __webpack_require__(39466);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ../../libs/templates/FormSubmitAction/FormSubmitAction.tsx


var _excluded = ["form", "status", "heading", "description", "buttonText", "buttonUrl", "onButtonClick", "buttonColor", "compact", "borderless", "tokens", "appearance"];

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}










var BaseFormSubmitAction = function BaseFormSubmitAction(_ref) {
  var form = _ref.form,
      status = _ref.status,
      heading = _ref.heading,
      description = _ref.description,
      buttonText = _ref.buttonText,
      buttonUrl = _ref.buttonUrl,
      onButtonClick = _ref.onButtonClick,
      _ref$buttonColor = _ref.buttonColor,
      buttonColor = _ref$buttonColor === void 0 ? "primary" : _ref$buttonColor,
      _ref$compact = _ref.compact,
      compact = _ref$compact === void 0 ? false : _ref$compact,
      _ref$borderless = _ref.borderless,
      borderless = _ref$borderless === void 0 ? false : _ref$borderless,
      tokens = _ref.tokens,
      externalAppearance = _ref.appearance,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  var theme = (0,emotion_element_6a883da9_browser_esm.u)();
  var appearance = (0,AppearanceContext/* useAppearance */.M)(externalAppearance);
  var localData = form && data[status][form];
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AppearanceContext/* AppearanceProvider */.x, {
    appearance: appearance,
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(FormSubmitAction_views/* Wrapper */.im, _objectSpread(_objectSpread(_objectSpread({
      borderless: borderless,
      compact: compact
    }, tokens.wrapper), rest), {}, {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(FormSubmitAction_views/* Header */.h4, {
        children: [status === "success" ? (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Common/* CheckIcon */.nQ, {
          color: theme.palette.status.success[100]
        }) : (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Common/* ClearIcon */.Rk, {
          color: theme.palette.status.error[100]
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormSubmitAction_views/* StyledTypography */.fN, {
          variant: "h4",
          tag: "p",
          tokens: tokens.header,
          children: heading || (localData === null || localData === void 0 ? void 0 : localData.heading)
        })]
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormSubmitAction_views/* StyledDescription */.MJ, {
        variant: "pMedium",
        tokens: tokens.description,
        children: description || (localData === null || localData === void 0 ? void 0 : localData.description)
      }), !compact && (buttonText || (localData === null || localData === void 0 ? void 0 : localData.buttonText)) && buttonText !== null && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormSubmitAction_views/* StyledButton */.Sn, {
        variant: "filled",
        size: "large",
        color: buttonColor,
        expanded: true,
        tag: "a",
        href: buttonUrl,
        onClick: onButtonClick,
        children: buttonText || (localData === null || localData === void 0 ? void 0 : localData.buttonText)
      })]
    }))
  });
};

var FormSubmitAction = (0,useDesignTokens/* withDesignTokens */.Y)(BaseFormSubmitAction, function () {
  return {};
}, {
  dark: function dark(theme) {
    return {
      wrapper: {
        borderColor: theme.palette.brand.darkAcai[300]
      },
      description: {
        color: theme.palette.brand.darkAcai[300]
      }
    };
  },
  light: function light(theme) {
    return {
      wrapper: {
        borderColor: theme.palette.brand.darkAcai[300]
      },
      description: {
        color: theme.palette.brand.darkAcai[500]
      }
    };
  },
  twilioLight: function twilioLight(theme) {
    return {
      wrapper: {
        borderColor: theme.palette.twilio.gray[30]
      },
      description: {
        color: theme.palette.twilio.gray[100]
      }
    };
  },
  twilioDark: function twilioDark(theme) {
    return {
      wrapper: {
        borderColor: theme.palette.neutrals.white[100]
      },
      description: {
        color: theme.palette.neutrals.white[100]
      }
    };
  },
  cdpWeek2023: function cdpWeek2023(theme) {
    return {
      wrapper: {
        borderColor: theme.palette.twilio.gray[30]
      },
      description: {
        color: theme.palette.twilio.gray[20]
      }
    };
  }
});
/* harmony default export */ var FormSubmitAction_FormSubmitAction = ((/* unused pure expression or super */ null && (FormSubmitAction)));
;// CONCATENATED MODULE: ../../libs/templates/FormSubmitAction/index.ts

FormSubmitAction.displayName = "FormSubmitAction";


/***/ }),

/***/ 53100:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ TrackableForm_TrackableForm; },
  "N": function() { return /* reexport */ errorMessage; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(20406);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(82269);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(28526);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ../../node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(63955);
// EXTERNAL MODULE: ../../node_modules/uuid/dist/esm-browser/v1.js
var v1 = __webpack_require__(43833);
// EXTERNAL MODULE: ../../libs/matcha/foundations/AppearanceContext/index.ts + 1 modules
var AppearanceContext = __webpack_require__(9381);
// EXTERNAL MODULE: ../../libs/matcha/recipes/CopyText/index.ts + 2 modules
var CopyText = __webpack_require__(94136);
// EXTERNAL MODULE: ../../libs/matcha/useDesignTokens/index.ts
var useDesignTokens = __webpack_require__(98439);
// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(28165);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Form/Form.views.tsx


function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}


var FormWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("form",  true ? {
  target: "eee57py5"
} : 0)( true ? {
  name: "1bmvmcg",
  styles: "margin:0;width:100%"
} : 0);
var FormContent = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "eee57py4"
} : 0)("margin:0;display:grid;justify-items:stretch;gap:", function (_ref) {
  var gap = _ref.gap;
  return gap;
}, ";", function (_ref2) {
  var gridAutoFlow = _ref2.gridAutoFlow,
      gridAutoColumns = _ref2.gridAutoColumns,
      theme = _ref2.theme;
  return (
    /*#__PURE__*/

    /*#__PURE__*/
    (0,emotion_react_browser_esm/* css */.iv)(theme.breakpoints.up("md"), "{grid-auto-flow:", gridAutoFlow, ";grid-auto-columns:", gridAutoColumns, ";}" + ( true ? "" : 0),  true ? "" : 0,  true ? "" : 0,  true ? "" : 0)
  );
}, ";" + ( true ? "" : 0));
var Before = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "eee57py3"
} : 0)( true ? "" : 0);
var After = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "eee57py2"
} : 0)( true ? "" : 0);
var Success = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "eee57py1"
} : 0)( true ? "" : 0);
var Error = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "eee57py0"
} : 0)( true ? "" : 0);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Form/Form.tsx


var _excluded = ["after", "appearance", "before", "children", "className", "methods", "gap", "success", "error", "tokens", "keepFieldsAfterSuccess", "submitCallback"];

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}








 // Set up global form defaults

var DefaultSuccessMessage = (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
  children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
    variant: "h3",
    children: "Thank you"
  }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Description */.dk, {
    variant: "pLarge",
    tag: "p",
    children: "Your submission was successful."
  })]
});

var BaseForm = function BaseForm(_ref) {
  var _methods$formState$er, _methods$formState$er2, _methods$formState$er3, _methods$formState$er4;

  var after = _ref.after,
      appearance = _ref.appearance,
      before = _ref.before,
      children = _ref.children,
      className = _ref.className,
      _ref$methods = _ref.methods,
      methods = _ref$methods === void 0 ? (0,index_esm/* useForm */.cI)({
    mode: "all"
  }) : _ref$methods,
      _ref$gap = _ref.gap,
      gap = _ref$gap === void 0 ? "medium" : _ref$gap,
      _ref$success = _ref.success,
      success = _ref$success === void 0 ? DefaultSuccessMessage : _ref$success,
      error = _ref.error,
      tokens = _ref.tokens,
      _ref$keepFieldsAfterS = _ref.keepFieldsAfterSuccess,
      keepFieldsAfterSuccess = _ref$keepFieldsAfterS === void 0 ? false : _ref$keepFieldsAfterS,
      submitCallback = _ref.submitCallback,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  var formAppearance = (0,AppearanceContext/* useAppearance */.M)(appearance);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AppearanceContext/* AppearanceProvider */.x, {
    appearance: formAppearance,
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_esm/* FormProvider */.RV, _objectSpread(_objectSpread({}, methods), {}, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(FormWrapper, _objectSpread(_objectSpread(_objectSpread({
        className: className,
        noValidate: true,
        onSubmit: submitCallback
      }, tokens.root), rest), {}, {
        children: [(keepFieldsAfterSuccess || !methods.formState.isSubmitSuccessful) && !((_methods$formState$er = methods.formState.errors) !== null && _methods$formState$er !== void 0 && (_methods$formState$er2 = _methods$formState$er.root) !== null && _methods$formState$er2 !== void 0 && _methods$formState$er2.serverError) && (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(FormContent, _objectSpread(_objectSpread({
          gap: gap
        }, tokens.content), {}, {
          children: [before && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Before, {
            children: before
          }), children, after && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(After, {
            children: after
          })]
        })), methods.formState.isSubmitSuccessful && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Success, {
          children: success,
          role: "alert"
        }), (_methods$formState$er3 = methods.formState.errors) !== null && _methods$formState$er3 !== void 0 && (_methods$formState$er4 = _methods$formState$er3.root) !== null && _methods$formState$er4 !== void 0 && _methods$formState$er4.serverError ? (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Error, {
          role: "alert",
          children: error
        }) : null]
      }))
    }))
  });
};

var Form = (0,useDesignTokens/* withDesignTokens */.Y)(BaseForm, function (_ref2) {
  var gap = _ref2.gap,
      layout = _ref2.layout;
  return {
    root: {},
    content: _objectSpread({
      gap: gap === "small" ? "32px" : "40px"
    }, layout === "column" && {
      gridAutoFlow: "column",
      gridAutoColumns: "auto max-content"
    })
  };
}, {
  dark: function dark() {
    return {};
  },
  light: function light() {
    return {};
  },
  twilioLight: function twilioLight() {
    return {};
  },
  twilioDark: function twilioDark() {
    return {};
  },
  cdpWeek2023: function cdpWeek2023() {
    return {};
  }
});
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Form/index.ts

// EXTERNAL MODULE: ../../libs/tracking/index.ts + 1 modules
var tracking = __webpack_require__(55156);
// EXTERNAL MODULE: ../../libs/tracking/scripts/index.ts + 2 modules
var scripts = __webpack_require__(17397);
;// CONCATENATED MODULE: ../../libs/templates/TrackableForm/TrackableForm.tsx



var TrackableForm_excluded = ["children", "onFailure", "overrideConsent", "customFormIdentifier", "customTrackingType", "methods", "onSubmit"];


function TrackableForm_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function TrackableForm_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? TrackableForm_ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : TrackableForm_ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}








var TrackableForm = function TrackableForm(_ref) {
  var children = _ref.children,
      onFailure = _ref.onFailure,
      overrideConsent = _ref.overrideConsent,
      customFormIdentifier = _ref.customFormIdentifier,
      customTrackingType = _ref.customTrackingType,
      _ref$methods = _ref.methods,
      methods = _ref$methods === void 0 ? (0,index_esm/* useForm */.cI)({
    mode: "all"
  }) : _ref$methods,
      onSubmit = _ref.onSubmit,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, TrackableForm_excluded);

  var _useTracking = (0,tracking/* useTracking */.r)(),
      identify = _useTracking.identify;

  var submitCallback = /*#__PURE__*/function () {
    var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(data) {
      var uniqueId;
      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              uniqueId = (0,v1/* default */.Z)(); // If there's a custom onSubmit, fire it

              if (!onSubmit) {
                _context.next = 13;
                break;
              }

              _context.prev = 2;
              _context.next = 5;
              return identify(TrackableForm_objectSpread(TrackableForm_objectSpread(TrackableForm_objectSpread(TrackableForm_objectSpread({}, data), customFormIdentifier && {
                customFormIdentifier: customFormIdentifier
              }), customTrackingType && {
                customTrackingType: customTrackingType
              }), {}, {
                server_message_id: uniqueId // eslint-disable-line camelcase

              }), overrideConsent);

            case 5:
              _context.next = 7;
              return onSubmit(TrackableForm_objectSpread(TrackableForm_objectSpread(TrackableForm_objectSpread(TrackableForm_objectSpread({}, data), customFormIdentifier && {
                customFormIdentifier: customFormIdentifier
              }), customTrackingType && {
                customTrackingType: customTrackingType
              }), {}, {
                server_message_id: uniqueId // eslint-disable-line camelcase

              }));

            case 7:
              _context.next = 13;
              break;

            case 9:
              _context.prev = 9;
              _context.t0 = _context["catch"](2);
              (0,scripts/* trackServerError */.qv)(data, customFormIdentifier || "", JSON.stringify(_context.t0));
              methods.setError("root.serverError", {
                type: "400"
              });

            case 13:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[2, 9]]);
    }));

    return function submitCallback(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  var errorCallback = function errorCallback(errors) {
    // This can be remove, but is handy for troubleshooting
    console.warn("Form errors!", errors); // If there's a custom onFailure event, fires it.

    if (onFailure) {
      onFailure(errors);
    }
  };

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Form, TrackableForm_objectSpread(TrackableForm_objectSpread({
    methods: methods,
    submitCallback: methods.handleSubmit(submitCallback, errorCallback)
  }, rest), {}, {
    children: children
  }));
};

/* harmony default export */ var TrackableForm_TrackableForm = (TrackableForm);
;// CONCATENATED MODULE: ../../libs/templates/TrackableForm/data/messages.ts
var errorMessage = {
  heading: "Something happened",
  description: "We are really sorry. There was an error processing your submission. Try reloading your browser, and submitting again."
};
;// CONCATENATED MODULE: ../../libs/templates/TrackableForm/index.ts



/***/ }),

/***/ 36219:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

var emailRegex = /^(?!.*@example\.com$)[\w-+.]+@([\w-]+\.)+[\w-]{2,}$/;
/* harmony default export */ __webpack_exports__["Z"] = (emailRegex);

/***/ }),

/***/ 63535:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

var formRegex = /^(?![\s\S]*[,;'"][?=+\-@\t\r])[^?=+\-@\t\r][\s\S]+$/g;
/* harmony default export */ __webpack_exports__["Z"] = (formRegex);

/***/ }),

/***/ 11703:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

var nameRegex = /.*/;
/* harmony default export */ __webpack_exports__["Z"] = (nameRegex);

/***/ }),

/***/ 68714:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* reexport safe */ _useScrollToAnchor__WEBPACK_IMPORTED_MODULE_0__.Z; },
/* harmony export */   "d": function() { return /* reexport safe */ _useScrollToAnchor__WEBPACK_IMPORTED_MODULE_0__.d; }
/* harmony export */ });
/* harmony import */ var _useScrollToAnchor__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(83390);


/***/ }),

/***/ 83390:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "d": function() { return /* binding */ scrollToAnchor; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);

var scrollToAnchor = function scrollToAnchor(anchorId) {
  var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var addAnchorToUrl = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  var anchor = document.getElementById(anchorId);

  if (anchor) {
    var y = anchor.getBoundingClientRect().top + window.pageYOffset + offset;
    window.scrollTo({
      top: y,
      behavior: "smooth"
    });

    if (addAnchorToUrl) {
      history.pushState({}, "", "#".concat(anchorId));
    }
  }
};
/**
 * Scroll into view, given an anchor (element.id)
 *
 * @param anchorId - element id to be queried and scrolled to.
 * @param offset - offset from the top of the element to scroll to.
 * @return a function that scrolls to the anchor.
 */

var useScrollToAnchor = function useScrollToAnchor(anchorId) {
  var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var scroll = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function () {
    scrollToAnchor(anchorId, offset);
  }, [anchorId, offset]);
  return scroll;
};

/* harmony default export */ __webpack_exports__["Z"] = (useScrollToAnchor);

/***/ })

}]);